/**
 * PW Stock Notify: global helpers (bridge snippet dispatches clicks; this file upgrades behavior).
 */
function clnfDeepQuerySelector(selector, root) {
  root = root || document;
  var found = null;
  try {
    found = root.querySelector(selector);
  } catch (_) {}
  if (found) return found;
  var nodes = root.querySelectorAll("*");
  for (var di = 0; di < nodes.length; di++) {
    var sh = nodes[di].shadowRoot;
    if (sh) {
      var inner = clnfDeepQuerySelector(selector, sh);
      if (inner) return inner;
    }
  }
  return null;
}

function findNotifyTriggerButton() {
  var el = document.getElementById("pw_notify_popup_open");
  if (el) return el;
  var blocks = document.querySelectorAll(
    '[id^="shopify-block-pw_stock_notify_app_block_"]'
  );
  for (var i = 0; i < blocks.length; i++) {
    el = blocks[i].querySelector("#pw_notify_popup_open");
    if (el) return el;
  }
  var form = document.getElementById("AddToCartForm");
  if (form) {
    el = form.querySelector("#pw_notify_popup_open");
    if (el) return el;
  }
  return clnfDeepQuerySelector("#pw_notify_popup_open");
}

/**
 * PW app.js binds popup open only if #pw_notify_popup_open and #mypw_model_popup exist when
 * app.js first runs. Async app-block injection leaves both as null forever in the app’s closure;
 * re-bind on live nodes (same behavior as their onclick handler).
 */
function clnfPatchPwStockNotifyAppClickBinding() {
  var modal =
    document.getElementById("mypw_model_popup") ||
    document.getElementById("pw_model_popup");
  var openEl = document.getElementById("pw_notify_popup_open");
  if (modal && modal.parentElement !== document.body) {
    try {
      document.body.appendChild(modal);
    } catch (_) {}
  }
  if (!modal || !openEl) return false;
  if (openEl.dataset.clnfPwRevealBound) return true;
  openEl.dataset.clnfPwRevealBound = "1";
  openEl.addEventListener(
    "click",
    function (ev) {
      var m =
        document.getElementById("mypw_model_popup") ||
        document.getElementById("pw_model_popup");
      if (!m) return;
      if (m.parentElement !== document.body) {
        try {
          document.body.appendChild(m);
        } catch (_) {}
      }
      m.style.display = "block";
      m.style.visibility = "visible";
      if (ev && ev.preventDefault) ev.preventDefault();
    },
    true
  );
  return true;
}

function openPwStockNotifyModal() {
  clnfPatchPwStockNotifyAppClickBinding();
  var popup =
    document.getElementById("mypw_model_popup") ||
    document.getElementById("pw_model_popup");
  if (!popup) {
    var appBlocks = document.querySelectorAll(
      '[id^="shopify-block-pw_stock_notify_app_block_"]'
    );
    for (var bi = 0; bi < appBlocks.length; bi++) {
      popup = appBlocks[bi].querySelector(
        "[id*='pw_model'], [id*='mypw_model'], .pw_model_popup, [class*='pw_model_popup'], [class*='pw-notify'], dialog"
      );
      if (popup) break;
    }
  }
  if (!popup) {
    popup = document.querySelector(
      '[id*="pw_model_popup"], [id*="mypw_model"], .pw_model_popup, dialog[open], dialog[data-pw-modal]'
    );
  }
  if (!popup) {
    popup = clnfDeepQuerySelector(
      "#mypw_model_popup, #pw_model_popup, [id*='pw_model_popup'], .pw_model_popup"
    );
  }
  if (!popup) {
    var iframes = document.querySelectorAll("iframe");
    for (var ii = 0; ii < iframes.length; ii++) {
      try {
        var idoc = iframes[ii].contentDocument;
        if (idoc) {
          popup =
            idoc.getElementById("mypw_model_popup") ||
            idoc.getElementById("pw_model_popup");
          if (popup) break;
        }
      } catch (_) {}
    }
  }
  if (!popup) return;
  if (popup.parentElement !== document.body) {
    try {
      document.body.appendChild(popup);
    } catch (_) {}
  }
  popup.style.display = "block";
  popup.style.visibility = "visible";
  try {
    popup.removeAttribute("hidden");
    if (typeof popup.showModal === "function" && popup.tagName === "DIALOG") {
      popup.showModal();
    }
  } catch (_) {}
}

function resolvePwNotifyFallbackTriggerFromEvent(e) {
  var path = typeof e.composedPath === "function" ? e.composedPath() : null;
  if (path && path.length) {
    for (var pi = 0; pi < path.length; pi++) {
      var n = path[pi];
      if (
        n &&
        n.nodeType === 1 &&
        n.classList &&
        n.classList.contains("js-pw-notify-fallback-trigger")
      ) {
        return n;
      }
    }
  }
  var raw = e.target;
  var el =
    raw && raw.nodeType === 1 ? raw : raw && raw.parentElement;
  return el && typeof el.closest === "function"
    ? el.closest(".js-pw-notify-fallback-trigger")
    : null;
}

function clnfClearTrackedTimeouts(timeoutIds) {
  for (var i = 0; i < timeoutIds.length; i++) {
    clearTimeout(timeoutIds[i]);
  }
  timeoutIds.length = 0;
}

var _clnfPwNotifyRevealPollId = null;
var _clnfPwNotifyRevealTimeoutIds = [];
function handlePwNotifyFallbackTriggerClick(e) {
  var t = resolvePwNotifyFallbackTriggerFromEvent(e);
  if (!t) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  clnfPatchPwStockNotifyAppClickBinding();
  var pwBtn = findNotifyTriggerButton();
  if (pwBtn) {
    pwBtn.classList.remove("hidden-notify-button");
    try {
      pwBtn.style.removeProperty("display");
      pwBtn.style.removeProperty("visibility");
      pwBtn.style.removeProperty("opacity");
      pwBtn.style.removeProperty("pointer-events");
      pwBtn.style.removeProperty("position");
      pwBtn.style.removeProperty("z-index");
      pwBtn.style.removeProperty("width");
      pwBtn.style.removeProperty("height");
    } catch (_) {}
    try {
      pwBtn.focus({ preventScroll: true });
    } catch (_) {}
    try {
      pwBtn.click();
    } catch (_) {}
    try {
      pwBtn.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );
    } catch (_) {}
  }
  if (_clnfPwNotifyRevealPollId) {
    clearInterval(_clnfPwNotifyRevealPollId);
    _clnfPwNotifyRevealPollId = null;
  }
  clnfClearTrackedTimeouts(_clnfPwNotifyRevealTimeoutIds);
  openPwStockNotifyModal();
  _clnfPwNotifyRevealTimeoutIds.push(
    setTimeout(openPwStockNotifyModal, 50)
  );
  _clnfPwNotifyRevealTimeoutIds.push(
    setTimeout(openPwStockNotifyModal, 200)
  );
  _clnfPwNotifyRevealTimeoutIds.push(
    setTimeout(openPwStockNotifyModal, 500)
  );
  var pollN = 0;
  _clnfPwNotifyRevealPollId = setInterval(function () {
    openPwStockNotifyModal();
    if (++pollN >= 35) {
      clearInterval(_clnfPwNotifyRevealPollId);
      _clnfPwNotifyRevealPollId = null;
    }
  }, 100);
}

window.clnfHandlePwFallbackClick = handlePwNotifyFallbackTriggerClick;
window.__clnfOpenPwStockNotifyModal = openPwStockNotifyModal;

/**
 * Shopify Subscriptions (1P): mirror PW Stock Notify — modal nodes under wetheme-product-form / Vue
 * get clipped or lost when the tree patches. Same pattern as clnfPatchPw / openPwStockNotifyModal:
 * promote modal to document.body, force show, capture-phase click on the widget + delayed retries.
 */
function clnfSubscriptionsModalBelongsToWidget(el) {
  if (!el || typeof el.closest !== "function") return false;
  return !!(
    el.closest(".clnf-shopify-subscriptions-root") ||
    el.closest('[id*="subscriptions_app_block"]')
  );
}

function clnfFindShopifySubscriptionsModal() {
  var roots = document.querySelectorAll(
    '.clnf-shopify-subscriptions-root, [id*="subscriptions_app_block"]'
  );
  var ri, el, list, i, j;
  for (ri = 0; ri < roots.length; ri++) {
    list = roots[ri].querySelectorAll("dialog");
    for (j = list.length - 1; j >= 0; j--) {
      if (list[j]) return list[j];
    }
  }
  for (ri = 0; ri < roots.length; ri++) {
    el = roots[ri].querySelector(
      "[id*='modal'], [id*='Modal'], [class*='modal'], .pw_model_popup"
    );
    if (el && clnfSubscriptionsModalBelongsToWidget(el)) return el;
  }
  var form = document.getElementById("AddToCartForm");
  if (form) {
    list = form.querySelectorAll(
      '.clnf-shopify-subscriptions-root dialog, [id*="subscriptions_app_block"] dialog'
    );
    for (j = list.length - 1; j >= 0; j--) {
      if (list[j]) return list[j];
    }
  }
  list = document.querySelectorAll("dialog");
  for (i = 0; i < list.length; i++) {
    if (clnfSubscriptionsModalBelongsToWidget(list[i])) return list[i];
  }
  el = clnfDeepQuerySelector("dialog");
  if (el && clnfSubscriptionsModalBelongsToWidget(el)) return el;
  return null;
}

function clnfPromoteShopifySubscriptionsModal(popup) {
  if (!popup || popup.nodeType !== 1) return;
  if (popup.parentElement !== document.body) {
    try {
      document.body.appendChild(popup);
    } catch (_) {}
  }
  try {
    popup.style.display = "block";
    popup.style.visibility = "visible";
  } catch (_) {}
  try {
    popup.removeAttribute("hidden");
    if (typeof popup.showModal === "function" && String(popup.tagName).toUpperCase() === "DIALOG") {
      popup.showModal();
    }
  } catch (_) {}
}

function clnfOpenShopifySubscriptionsModal() {
  clnfPatchShopifySubscriptionsModalBinding();
  var popup = clnfFindShopifySubscriptionsModal();
  if (!popup) return;
  clnfPromoteShopifySubscriptionsModal(popup);
}

var _clnfSubModalRevealPollId = null;
var _clnfSubModalRevealTimeoutIds = [];
function clnfScheduleShopifySubscriptionsModalReveal() {
  if (_clnfSubModalRevealPollId) {
    clearInterval(_clnfSubModalRevealPollId);
    _clnfSubModalRevealPollId = null;
  }
  clnfClearTrackedTimeouts(_clnfSubModalRevealTimeoutIds);
  clnfOpenShopifySubscriptionsModal();
  _clnfSubModalRevealTimeoutIds.push(
    setTimeout(clnfOpenShopifySubscriptionsModal, 50)
  );
  _clnfSubModalRevealTimeoutIds.push(
    setTimeout(clnfOpenShopifySubscriptionsModal, 200)
  );
  _clnfSubModalRevealTimeoutIds.push(
    setTimeout(clnfOpenShopifySubscriptionsModal, 500)
  );
  var pollN = 0;
  _clnfSubModalRevealPollId = setInterval(function () {
    clnfOpenShopifySubscriptionsModal();
    if (++pollN >= 35) {
      clearInterval(_clnfSubModalRevealPollId);
      _clnfSubModalRevealPollId = null;
    }
  }, 100);
}

function clnfPatchShopifySubscriptionsModalBinding() {
  var root = document.querySelector(".clnf-shopify-subscriptions-root");
  if (!root) return false;

  var early = clnfFindShopifySubscriptionsModal();
  if (early) clnfPromoteShopifySubscriptionsModal(early);

  if (root.dataset.clnfSubscriptionsModalBound === "1") return true;
  root.dataset.clnfSubscriptionsModalBound = "1";

  root.addEventListener(
    "click",
    function () {
      clnfScheduleShopifySubscriptionsModalReveal();
    },
    true
  );

  var form = document.getElementById("AddToCartForm");
  if (form && form.dataset.clnfSubscriptionsModalFormBound !== "1") {
    form.dataset.clnfSubscriptionsModalFormBound = "1";
    var subModalLayTimer = null;
    form.addEventListener(
      "change",
      function () {
        if (subModalLayTimer) clearTimeout(subModalLayTimer);
        subModalLayTimer = setTimeout(function () {
          subModalLayTimer = null;
          clnfOpenShopifySubscriptionsModal();
        }, 220);
      },
      { passive: true }
    );
  }

  return true;
}

window.__clnfOpenShopifySubscriptionsModal = clnfOpenShopifySubscriptionsModal;

function runProductCustomDomReady() {
  /** Parsed product JSON (DOM script tag is static per PDP load). Avoids JSON.parse on every variant sync. */
  var clnfCachedProductForClp;
  var clnfClpVariantPollTimer = null;

  /**
   * Read variant id from a swatch row. Prefer data-variant-id (dataset.variantId); keep legacy
   * data-variantId / dataset.variantid fallbacks for cached HTML.
   */
  function clnfReadSwatchRowVariantId(row) {
    if (!row) return "";
    var id =
      (row.dataset && (row.dataset.variantId || row.dataset.variantid)) ||
      row.getAttribute("data-variant-id") ||
      row.getAttribute("data-variantId") ||
      row.getAttribute("data-variantid");
    return id ? String(id).trim() : "";
  }

  /**
   * Document-delegated capture so Vue remounts cannot orphan form listeners.
   * On single-option PDPs, apply the clicked row's variant id to select/hidden inputs immediately —
   * Vue updates select[name=id] one microtask later, and a fast ATC in that window would submit the
   * previous size (e.g. 50 lb shown, 5 lb added).
   */
  function clnfBindSwatchVariantCapture() {
    if (window.__clnfSwatchCaptureBound) return;
    window.__clnfSwatchCaptureBound = true;

    function applyPickedFromSwatchRow(row, form, eventType) {
      if (!row || !form || !form.contains(row)) return;
      var id = clnfReadSwatchRowVariantId(row);
      if (!id || !clnfVariantIdIsOnProduct(id)) return;
      form.dataset.clnfPickedVariant = id;

      var product = getParsedProductJsonForClp();
      var oneOpt =
        product && Array.isArray(product.options) && product.options.length === 1;
      if (oneOpt) {
        clnfApplyResolvedVariantIdToForm(form, id);
        return;
      }
      // Multi-option: radios may still be stale during click capture — sync on change / ATC.
      if (eventType === "change") {
        clnfSyncVariantSelectToSelectedOptions();
      }
    }

    function onSwatchInteract(ev) {
      var form = document.getElementById("AddToCartForm");
      if (!form) return;
      var t = ev.target;
      if (!t || !t.closest) return;
      if (ev.type === "change" && t.type !== "radio") return;
      var row = t.closest(".swatch-element");
      if (!row || !form.contains(row)) return;
      applyPickedFromSwatchRow(row, form, ev.type);
    }

    document.addEventListener("click", onSwatchInteract, true);
    document.addEventListener("change", onSwatchInteract, true);
  }
  clnfBindSwatchVariantCapture();

  function syncCcCardSelectedState() {
    document
      .querySelectorAll(".swatch-items-wrapper.cc-size-mode .swatch-element.cc-card")
      .forEach(function (card) {
        var radio = card.querySelector('input[type="radio"]');
        card.classList.toggle("cc-card--selected", !!(radio && radio.checked));
      });
  }

  /**
   * Keep .cc-card--selected in step with the checked radio.
   *
   * This class is the non-:has() fallback for the active size card (see clnf-product-pdp.css) and
   * must never go stale: on a WebView without :has() support — the MobiLoud app wrapper included —
   * it is the ONLY thing that highlights the selected card, and where :has() *is* supported a stale
   * class leaves the previously selected card highlighted alongside the new one (two cards appear
   * selected at once).
   *
   * Bind on `document`, never on #AddToCartForm. WeTheme's Vue inline-template mount rebuilds the
   * form subtree, which both drops listeners bound to the pre-mount form node AND bakes any
   * data-* rebind flag we set on it into the compiled render function — so the replacement node
   * comes back already marked "bound" while carrying no listeners, and a form-scoped guard would
   * refuse to rebind for the life of the page. Document-level capture survives every remount.
   */
  function clnfBindCcCardSelectedStateSync() {
    syncCcCardSelectedState();
    if (window.__clnfCcCardSelectedSyncBound) return;
    window.__clnfCcCardSelectedSyncBound = true;

    // Covers swatch radios and the `change` WeTheme dispatches on #AddToCartForm once Vue settles.
    document.addEventListener("change", syncCcCardSelectedState, true);
    // Label activation checks the radio *after* the label's click event, so defer a frame.
    document.addEventListener(
      "click",
      function (ev) {
        if (ev.target && ev.target.closest && ev.target.closest(".swatch-element.cc-card")) {
          requestAnimationFrame(syncCcCardSelectedState);
        }
      },
      true
    );
    // Vue mounts after DOMContentLoaded and re-renders the cards from the initial variant; re-sync
    // so the first paint is correct even before the shopper touches anything.
    window.addEventListener("load", syncCcCardSelectedState);
    [100, 400, 1200, 3000].forEach(function (ms) {
      window.setTimeout(syncCcCardSelectedState, ms);
    });
  }
  clnfBindCcCardSelectedStateSync();

  function clnfVariantIdIsOnProduct(vid) {
    var product = getParsedProductJsonForClp();
    if (!product || !Array.isArray(product.variants) || vid == null || vid === "") return false;
    var s = String(vid).trim();
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i] && String(product.variants[i].id) === s) return true;
    }
    return false;
  }

  /** Picked swatch row variant matches current option radios (avoids wrong id when Shopify has Title + Size). */
  function clnfPickedVariantMatchesCheckedOptions(pickedId) {
    var product = getParsedProductJsonForClp();
    if (!product || !Array.isArray(product.variants) || !pickedId) return false;
    var want = null;
    var pid = String(pickedId).trim();
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i] && String(product.variants[i].id) === pid) {
        want = product.variants[i];
        break;
      }
    }
    if (!want || !Array.isArray(want.options)) return false;
    var selected = clnfReadSelectedProductOptionValues();
    if (!selected || selected.length !== want.options.length) return false;
    for (var j = 0; j < selected.length; j++) {
      if (String(want.options[j]) !== String(selected[j])) return false;
    }
    return true;
  }

  function clnfResolveAtcVariantId() {
    var form = document.getElementById("AddToCartForm");
    if (form) clnfNeutralizeSpuriousFormVariantNameIds(form);

    // Prefer live option radios over select[name=id] — Vue lags the select by a microtask after
    // swatch clicks, so FormData would otherwise submit the previous size.
    clnfSyncVariantSelectToSelectedOptions();
    var matched = clnfFindVariantForSelectedOptions();
    if (matched && matched.id != null) return String(matched.id);

    /** Last-click swatch row — only when it still matches checked options (multi-option safety). */
    var pickedEarly =
      form && form.dataset.clnfPickedVariant ? String(form.dataset.clnfPickedVariant).trim() : "";
    if (pickedEarly && clnfVariantIdIsOnProduct(pickedEarly) && clnfPickedVariantMatchesCheckedOptions(pickedEarly)) {
      return pickedEarly;
    }

    if (!form) return null;
    var sel = clnfGetCanonicalVariantSelect(form);
    if (sel && sel.value && clnfVariantIdIsOnProduct(sel.value)) return String(sel.value);
    var hid = form.querySelectorAll('input[name="id"]');
    for (var h = 0; h < hid.length; h++) {
      var el = hid[h];
      if (!el || el.disabled) continue;
      if (el.type !== "hidden" && el.type !== "") continue;
      if (el.value && clnfVariantIdIsOnProduct(el.value)) return String(el.value);
    }
    try {
      var urlVariant = new URL(window.location.href).searchParams.get("variant");
      if (urlVariant && clnfVariantIdIsOnProduct(urlVariant)) return String(urlVariant);
    } catch (_) {}
    // Single-option fallback: last clicked swatch row even if radio read lagged (label click capture).
    if (pickedEarly && clnfVariantIdIsOnProduct(pickedEarly)) {
      var product = getParsedProductJsonForClp();
      if (product && Array.isArray(product.options) && product.options.length === 1) {
        return pickedEarly;
      }
    }
    return null;
  }

  function clnfGetCanonicalVariantSelect(form) {
    var root = form || document.getElementById("AddToCartForm");
    if (!root) return null;
    return (
      root.querySelector("select.product-single__variants[name='id']") ||
      root.querySelector("select[id^='productSelect-'][name='id']") ||
      root.querySelector("select.product-single__variants") ||
      null
    );
  }

  /**
   * PayWorks (and some app blocks) inject <select name="id"> inside #AddToCartForm.
   * WeTheme's onAddToCart jQuery-serializes the whole form, so a second name="id" can
   * override the canonical product select (often sticking on the first/1 lb variant).
   * Strip name from non-canonical selects; keep a data attr so the app can still find the node.
   */
  function clnfNeutralizeSpuriousFormVariantNameIds(root) {
    var form = root || document.getElementById("AddToCartForm");
    if (!form) return;
    var selects = form.querySelectorAll('select[name="id"]');
    for (var i = 0; i < selects.length; i++) {
      var sel = selects[i];
      if (!sel) continue;
      if (sel.classList && sel.classList.contains("product-single__variants")) continue;
      if (sel.id && String(sel.id).indexOf("productSelect-") === 0) continue;
      if (!sel.getAttribute("data-clnf-was-name")) {
        sel.setAttribute("data-clnf-was-name", "id");
      }
      sel.removeAttribute("name");
    }
  }

  function clnfBindSpuriousVariantIdNeutralizer() {
    clnfNeutralizeSpuriousFormVariantNameIds();
    if (window.__clnfSpuriousVariantIdObserver) {
      try {
        window.__clnfSpuriousVariantIdObserver.disconnect();
      } catch (_) {}
      window.__clnfSpuriousVariantIdObserver = null;
    }
    var form = document.getElementById("AddToCartForm");
    if (!form || typeof MutationObserver === "undefined") return;
    var obs = new MutationObserver(function () {
      clnfNeutralizeSpuriousFormVariantNameIds(form);
    });
    obs.observe(form, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["name"],
    });
    window.__clnfSpuriousVariantIdObserver = obs;
    window.setTimeout(function () {
      if (window.__clnfSpuriousVariantIdObserver !== obs) return;
      try {
        obs.disconnect();
      } catch (_) {}
      if (window.__clnfSpuriousVariantIdObserver === obs) {
        window.__clnfSpuriousVariantIdObserver = null;
      }
    }, 120000);
  }
  clnfBindSpuriousVariantIdNeutralizer();

  function clnfApplyResolvedVariantIdToForm(form, variantId) {
    if (!form || variantId == null || variantId === "") return;
    var vid = String(variantId).trim();
    if (!vid) return;
    clnfNeutralizeSpuriousFormVariantNameIds(form);
    var select = clnfGetCanonicalVariantSelect(form);
    if (select) {
      select.value = vid;
      for (var si = 0; si < select.options.length; si++) {
        select.options[si].selected = select.options[si].value === vid;
      }
    }
    var inputs = form.querySelectorAll('input[name="id"]');
    for (var ii = 0; ii < inputs.length; ii++) {
      var inp = inputs[ii];
      if (!inp || inp.disabled) continue;
      if (inp.type !== "hidden" && inp.type !== "") continue;
      // Skip app-injected hidden ids that are not this product's variants.
      if (inp.value && !clnfVariantIdIsOnProduct(inp.value)) continue;
      inp.value = vid;
    }
  }

  function clnfSyncVariantBeforeAtc() {
    var form = document.getElementById("AddToCartForm");
    if (!form) return;
    clnfNeutralizeSpuriousFormVariantNameIds(form);
    var vid = clnfResolveAtcVariantId();
    if (vid) clnfApplyResolvedVariantIdToForm(form, vid);
  }

  /**
   * WeTheme's wetheme-product-form Vue component computes `variant` from option1/2/3 as a plain
   * getter — it is always correct the instant a swatch click updates those (v-model on the radio
   * runs synchronously with the click). But onAddToCart (bound on #AddToCartForm's "submit", no
   * capture) does not read this.variant at all — it jQuery-serializes the DOM form, and Vue only
   * mirrors variant.id onto select[name=id]/hidden input[name=id] on its next async re-render.
   * A fast tap (swatch then ATC before that re-render lands) submits whatever id was already in
   * the DOM. Reconstructing the swatch match independently in vanilla JS (clnfResolveAtcVariantId)
   * cannot fully close this gap — it's a second, separate implementation of variant matching that
   * can disagree with Vue's own. Reading Vue's `variant` getter directly and forcing the DOM to
   * match it is authoritative by construction.
   *
   * The fix relies on DOM event ordering, not timing: submit events bubble, and a capture-phase
   * listener anywhere above the target (here, document) always runs before a target-phase listener
   * on the target itself (WeTheme's onAddToCart, bound directly on the form without capture) — no
   * matter which was attached first, how the submit was triggered (click, Enter key, etc), or
   * whether Vue has replaced the form node since page load (document itself never gets replaced,
   * so unlike a listener bound directly to the form this needs no rebinding after Vue (re)mounts).
   *
   * Important: WeTheme mounts a parent Vue on `.product-form-vue` and registers `wetheme-product-form`
   * as a child. After inline-template compile, the physical <wetheme-product-form> node is often
   * gone, so falling back to mount.__vue__ returns the parent (no option1/variant) and the hard
   * guard silently no-ops. Walk $children to find the product-form VM that owns variant.
   */
  function clnfVueVmHasProductVariant(vm) {
    if (!vm) return false;
    var variant = vm.variant;
    if (!variant || variant.id == null) return false;
    // Parent mount shell can theoretically expose unrelated objects — require option state.
    return vm.option1 !== undefined || vm.option2 !== undefined || vm.option3 !== undefined;
  }

  function clnfWalkVueForProductFormVm(vm, depth) {
    if (!vm || depth > 12) return null;
    if (clnfVueVmHasProductVariant(vm)) return vm;
    var children = vm.$children;
    if (!children || !children.length) return null;
    for (var i = 0; i < children.length; i++) {
      var found = clnfWalkVueForProductFormVm(children[i], depth + 1);
      if (found) return found;
    }
    return null;
  }

  function clnfGetProductFormVueInstance() {
    var wf = document.querySelector("wetheme-product-form");
    if (wf && wf.__vue__) {
      if (clnfVueVmHasProductVariant(wf.__vue__)) return wf.__vue__;
      var fromWf = clnfWalkVueForProductFormVm(wf.__vue__, 0);
      if (fromWf) return fromWf;
    }
    var mount = document.querySelector(".product-form-vue");
    if (mount && mount.__vue__) {
      if (clnfVueVmHasProductVariant(mount.__vue__)) return mount.__vue__;
      var fromMount = clnfWalkVueForProductFormVm(mount.__vue__, 0);
      if (fromMount) return fromMount;
    }
    return null;
  }
  window.__clnfGetProductFormVueInstance = clnfGetProductFormVueInstance;

  function clnfBindHardVariantSubmitGuard() {
    if (window.__clnfHardVariantSubmitGuardBound) return;
    window.__clnfHardVariantSubmitGuardBound = true;
    document.addEventListener(
      "submit",
      function (ev) {
        var form = ev && ev.target;
        if (!form || form.id !== "AddToCartForm") return;
        clnfNeutralizeSpuriousFormVariantNameIds(form);
        var vue = clnfGetProductFormVueInstance();
        var variant = vue && vue.variant;
        if (variant && variant.id != null) {
          clnfApplyResolvedVariantIdToForm(form, variant.id);
          return;
        }
        // Vue CE compiled away / not ready: fall back to checked swatches / canonical select.
        var vid = clnfResolveAtcVariantId();
        if (vid) clnfApplyResolvedVariantIdToForm(form, vid);
      },
      true
    );
  }
  clnfBindHardVariantSubmitGuard();

  /** Upnova and some ATC paths fire cart/add on mousedown — sync before click handlers run. */
  function clnfBindAtcVariantSyncGuards() {
    if (window.__clnfAtcVariantSyncBound) return;
    window.__clnfAtcVariantSyncBound = true;
    function maybeSync(ev) {
      if (!ev || !ev.target || !ev.target.closest) return;
      if (!ev.target.closest(PRODUCT_ATC_SELECTOR)) return;
      if (!document.getElementById("AddToCartForm")) return;
      clnfSyncVariantBeforeAtc();
    }
    document.addEventListener("mousedown", maybeSync, true);
    document.addEventListener("pointerdown", maybeSync, true);
    document.addEventListener("click", maybeSync, true);
  }

  var PRODUCT_ATC_SELECTOR = ".js-product-atc-btn";
  clnfBindAtcVariantSyncGuards();
  function queryAllProductAtcButtons() {
    return document.querySelectorAll(PRODUCT_ATC_SELECTOR);
  }
  function isElementEffectivelyVisible(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden") return false;
    if (parseFloat(cs.opacity || "1") === 0) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 1 && r.height < 1) return false;
    return true;
  }
  /** Prefer the ATC row the shopper actually sees (mobile sticky vs desktop main). */
  function getPrimaryProductAtcButton() {
    var list = queryAllProductAtcButtons();
    for (var i = 0; i < list.length; i++) {
      if (isElementEffectivelyVisible(list[i])) return list[i];
    }
    return list.length ? list[0] : null;
  }
  function getActiveOnloadNotifyContainer() {
    var nodes = document.querySelectorAll(".js-onload-notify");
    if (!nodes.length) return null;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var cs = window.getComputedStyle(el);
      if (cs.display === "none" || cs.visibility === "hidden") continue;
      var r = el.getBoundingClientRect();
      if (r.width < 2 && r.height < 2) continue;
      return el;
    }
    return nodes[0];
  }

  /**
   * Mount notify next to the visible buy buttonâ€™s wrapper (desktop #AddToCart--main or mobile #AddToCart--sticky).
   */
  function getNotifyMountContainer() {
    var atc = getPrimaryProductAtcButton();
    if (atc) {
      var wrap = atc.closest(".js-onload-notify");
      if (wrap) return wrap;
      wrap = atc.closest(".paymentButtonsWrapper");
      if (wrap) {
        wrap.classList.add("js-onload-notify");
        return wrap;
      }
    }
    return getActiveOnloadNotifyContainer();
  }

  /** True when WeTheme marked ready on either the custom element or the Vue mount root (inline template compiles away <wetheme-product-form>). */
  function clnfProductFormVueReadyPresent() {
    return !!(
      document.querySelector("wetheme-product-form.product-form--ready") ||
      document.querySelector(".product-form-vue.product-form--ready")
    );
  }

  function markProductFormVueReady() {
    var wf = document.querySelector("wetheme-product-form");
    var mount = document.querySelector(".product-form-vue");
    var target = null;
    if (wf && wf.__vue__) {
      target = wf;
    } else if (mount && mount.__vue__) {
      target = mount;
    }
    if (!target) return false;

    // Guard: if the child gallery element is present, wait until its Vue instance mounts
    var singleWrapper = target.querySelector(".product-single-wrapper");
    if (singleWrapper && !singleWrapper.__vue__) {
      return false; // Keep retrying until child component finishes mounting
    }

    target.classList.add("product-form--ready");

    // Dynamic Getter for mediaTargets to bypass Vue 2 static duplicate ref limitation
    var instances = [target];
    if (singleWrapper) instances.push(singleWrapper);

    instances.forEach(function(inst) {
      if (inst && inst.__vue__ && inst.__vue__.$refs) {
        Object.defineProperty(inst.__vue__.$refs, 'mediaTargets', {
          get: function() {
            return Array.from(inst.querySelectorAll('.product-medias__slide, [ref="mediaTargets"]'));
          },
          set: function() {}, // No-op to prevent Vue patch from overwriting it during re-renders
          configurable: true,
          enumerable: true
        });
      }
    });

    if (!target.__clnfSubscriptionPlansReboundOnce) {
      target.__clnfSubscriptionPlansReboundOnce = true;
      function clnfSubRebindAfterVue() {
        if (typeof window.clnfReinitSubscriptionPlansByCustomer === "function") {
          window.clnfReinitSubscriptionPlansByCustomer();
        }
      }
      clnfSubRebindAfterVue();
      [50, 200, 550].forEach(function (ms) {
        setTimeout(clnfSubRebindAfterVue, ms);
      });
    }
    return true;
  }
  if (!markProductFormVueReady()) {
    var _vueReadyTries = 0;
    var _vueReadyTimer = setInterval(function () {
      if (markProductFormVueReady() || ++_vueReadyTries > 120) clearInterval(_vueReadyTimer);
    }, 50);
  }
  var _clnfNotifyObserver = null;
  var _clnfGalleryHeightObs = null;
  document.addEventListener("shopify:section:load", function () {
    if (_clnfNotifyObserver) { _clnfNotifyObserver.disconnect(); }
    if (_clnfGalleryHeightObs) { _clnfGalleryHeightObs.disconnect(); _clnfGalleryHeightObs = null; }
    clnfCachedProductForClp = undefined;
    clnfBindSwatchVariantCapture();
    clnfBindHardVariantSubmitGuard();
    clnfBindSpuriousVariantIdNeutralizer();
    clnfBindCcCardSelectedStateSync();
    var wf = document.querySelector("wetheme-product-form");
    var mount = document.querySelector(".product-form-vue");
    if (wf) {
      wf.classList.remove("product-form--ready");
      wf.__clnfSubscriptionPlansReboundOnce = false;
    }
    if (mount) {
      mount.classList.remove("product-form--ready");
      mount.__clnfSubscriptionPlansReboundOnce = false;
    }
    setTimeout(function () {
      var n = 0;
      var t2 = setInterval(function () {
        if (markProductFormVueReady() || ++n > 80) {
          clearInterval(t2);
          clnfPatchShopifySubscriptionsModalBinding();
          clnfScheduleClpPointsSync();
        }
      }, 50);
    }, 30);
    setTimeout(function () {
      _clnfSwiperBindTries = 0;
      document.querySelectorAll(".product-medias__main .swiper-container").forEach(function (c) {
        c._clnfSwiperSlideSyncBound = false;
      });
      scheduleProductMediaSwiperSyncBind();
    }, 300);
    setTimeout(function () {
      if (!_clnfNotifyObserver) return;
      var root = document.getElementById("AddToCartForm") ||
        document.querySelector(".product-form") ||
        document.querySelector('[id^="shopify-section-template--product"]') ||
        document.body;
      _clnfNotifyObserver.observe(root, { childList: true, subtree: true });
    }, 400);
  });

  clnfPatchShopifySubscriptionsModalBinding();

  /**
   * Keep ?variant= in sync with the form so a full reload matches the selected variant.
   * Shopify Subscriptions and Liquid use the URL variant on SSR; without it, reload can
   * serve the default variant while the picker shows another (empty subscription UI).
   */
  function clnfReadSelectedProductOptionValues() {
    var product = getParsedProductJsonForClp();
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    if (!variants.length) return null;

    var optionCount = 0;
    if (Array.isArray(product.options)) {
      optionCount = product.options.length;
    }
    if (!optionCount && Array.isArray(variants[0].options)) {
      optionCount = variants[0].options.length;
    }
    if (!optionCount) return null;

    var form = document.getElementById("AddToCartForm");
    var root = form || document;

    var values = [];
    for (var i = 0; i < optionCount; i++) {
      var value = "";
      var swatchInput = root.querySelector(
        '.custom-swatch-box[data-option-index="' + i + '"] input[type="radio"]:checked'
      );
      if (swatchInput && swatchInput.value) {
        value = swatchInput.value;
      }
      if (!value) {
        var dropdown = root.querySelector("#SingleOptionSelector-" + i) || document.getElementById("SingleOptionSelector-" + i);
        if (dropdown && dropdown.value) value = dropdown.value;
      }
      if (!value && Array.isArray(product.options)) {
        var optLabel = String(product.options[i] || "").toLowerCase();
        if (optLabel === "title") {
          var v0 = variants[0];
          if (v0 && Array.isArray(v0.options) && v0.options[i] != null) {
            value = String(v0.options[i]);
          }
        }
      }
      if (!value) return null;
      values.push(String(value));
    }
    return values;
  }

  function clnfFindVariantForSelectedOptions() {
    var product = getParsedProductJsonForClp();
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    var selectedOptions = clnfReadSelectedProductOptionValues();
    if (!variants.length || !selectedOptions) return null;

    for (var i = 0; i < variants.length; i++) {
      var variantOptions = Array.isArray(variants[i].options) ? variants[i].options : [];
      if (variantOptions.length !== selectedOptions.length) continue;
      var matches = true;
      for (var j = 0; j < selectedOptions.length; j++) {
        if (String(variantOptions[j]) !== selectedOptions[j]) {
          matches = false;
          break;
        }
      }
      if (matches) return variants[i];
    }
    return null;
  }

  function clnfSyncVariantSelectToSelectedOptions() {
    var form = document.getElementById("AddToCartForm");
    if (!form) return false;
    var variant = clnfFindVariantForSelectedOptions();
    if (!variant || !variant.id) return false;

    var variantId = String(variant.id);
    var changed = false;

    // Shopify product forms often submit hidden input[name="id"] even when a select exists (sometimes several).
    // Keep ALL in sync so ATC never reads a stale duplicate left on the first variant.
    var idInputs = form.querySelectorAll('input[name="id"]');
    for (var hi = 0; hi < idInputs.length; hi++) {
      var hiEl = idInputs[hi];
      if (!hiEl || hiEl.disabled) continue;
      if (hiEl.type !== "hidden" && hiEl.type !== "") continue;
      if (hiEl.value !== variantId) {
        hiEl.value = variantId;
        changed = true;
      }
    }

    var select = form.querySelector(".product-single__variants[name='id']");
    if (select && select.value !== variantId) {
      select.value = variantId;
      for (var i = 0; i < select.options.length; i++) {
        select.options[i].selected = select.options[i].value === variantId;
      }
      changed = true;
    }
    var sawHidden = false;
    var hiddenAligned = true;
    for (var hj = 0; hj < idInputs.length; hj++) {
      var hjEl = idInputs[hj];
      if (!hjEl || hjEl.disabled) continue;
      if (hjEl.type !== "hidden" && hjEl.type !== "") continue;
      sawHidden = true;
      if (hjEl.value !== variantId) hiddenAligned = false;
    }
    return changed || (!!select && select.value === variantId) || (sawHidden && hiddenAligned);
  }

  function clnfSyncProductVariantInUrl() {
    clnfSyncVariantSelectToSelectedOptions();
    var form = document.getElementById("AddToCartForm");
    if (!form || !window.location.pathname || window.location.pathname.indexOf("/products/") !== 0) {
      return;
    }
    clnfNeutralizeSpuriousFormVariantNameIds(form);
    var idEl = clnfGetCanonicalVariantSelect(form) || form.querySelector('input[name="id"]');
    if (!idEl || !idEl.value) return;
    var vid = String(idEl.value).trim();
    if (!vid || !clnfVariantIdIsOnProduct(vid)) return;
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get("variant") === vid) return;
      url.searchParams.set("variant", vid);
      window.history.replaceState(
        {},
        "",
        url.pathname + url.search + url.hash
      );
    } catch (_) {
      var raw = (window.location.search || "").replace(/^\?/, "");
      var params = new URLSearchParams(raw);
      if (params.get("variant") === vid) return;
      params.set("variant", vid);
      var qs = params.toString();
      window.history.replaceState(
        {},
        "",
        window.location.pathname + (qs ? "?" + qs : "") + (window.location.hash || "")
      );
    }
  }

  /**
   * UpNova jasmine's It() listens for native `change` on the first `input[name=id], select[name=id]`.
   * WeTheme/Vue set the canonical select via v-model and dispatch `change` on #AddToCartForm only,
   * so the volume widget stays on the first size. After Vue settles, fire `change` on the select
   * (value already matches — v-model is a no-op) plus variant:change / variant:changed.
   * Bind on document: Vue may replace the form node.
   */
  var clnfLastVariantChangeDispatchedId = "";
  var clnfVariantChangeMatchRetries = 0;

  function clnfLookupVariantById(vid) {
    var vue = clnfGetProductFormVueInstance();
    if (vue && vue.variant && String(vue.variant.id) === String(vid)) return vue.variant;
    var product = getParsedProductJsonForClp();
    if (!product || !Array.isArray(product.variants)) return null;
    var s = String(vid);
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i] && String(product.variants[i].id) === s) return product.variants[i];
    }
    return null;
  }

  function clnfSyncStrayChatVariantId(vid) {
    if (!vid) return;
    var chat = document.getElementById("chat-add-to-cart");
    if (!chat) return;
    var inputs = chat.querySelectorAll('input[name="id"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i]) inputs[i].value = String(vid);
    }
  }

  function clnfDispatchVariantChangeForApps(variantId) {
    if (window.__clnfDispatchingVariantChangeForApps) return;
    var form = document.getElementById("AddToCartForm");
    if (!form) return;

    var vue = clnfGetProductFormVueInstance();
    var vid = "";
    if (variantId != null && variantId !== "") {
      vid = String(variantId).trim();
    } else if (vue && vue.variant && vue.variant.id != null) {
      vid = String(vue.variant.id);
    }
    var select = clnfGetCanonicalVariantSelect(form);
    if (!vid && select && select.value) vid = String(select.value);
    if (!vid || !clnfVariantIdIsOnProduct(vid)) return;

    clnfSyncStrayChatVariantId(vid);

    if (select && String(select.value) !== vid) {
      if (clnfVariantChangeMatchRetries < 3) {
        clnfVariantChangeMatchRetries += 1;
        requestAnimationFrame(function () {
          clnfDispatchVariantChangeForApps(vid);
        });
      }
      return;
    }
    clnfVariantChangeMatchRetries = 0;
    if (clnfLastVariantChangeDispatchedId === vid) return;
    clnfLastVariantChangeDispatchedId = vid;

    var variant = clnfLookupVariantById(vid) || { id: vid };
    window.__clnfDispatchingVariantChangeForApps = true;
    try {
      if (select) {
        var changeEvt;
        try {
          changeEvt = new Event("change", { bubbles: true });
        } catch (_) {
          changeEvt = document.createEvent("HTMLEvents");
          changeEvt.initEvent("change", true, false);
        }
        select.dispatchEvent(changeEvt);
      }
      document.dispatchEvent(
        new CustomEvent("variant:change", { bubbles: true, detail: { variant: variant, id: vid } })
      );
      document.dispatchEvent(
        new CustomEvent("variant:changed", { bubbles: true, detail: { variant: variant, id: vid } })
      );
    } finally {
      window.__clnfDispatchingVariantChangeForApps = false;
    }
  }

  function clnfScheduleVariantChangeForApps() {
    requestAnimationFrame(function () {
      clnfDispatchVariantChangeForApps();
    });
    window.setTimeout(function () {
      clnfDispatchVariantChangeForApps();
    }, 50);
  }

  function clnfEventIsProductOptionRadio(t) {
    if (!t || !t.closest) return false;
    if (!t.closest("#AddToCartForm")) return false;
    if (t.matches && t.matches('.swatch-element input[type="radio"], input[name^="option"]')) return true;
    return false;
  }

  function clnfBindVariantChangeForApps() {
    if (window.__clnfVariantChangeForAppsBound) return;
    window.__clnfVariantChangeForAppsBound = true;
    document.addEventListener(
      "change",
      function (ev) {
        var t = ev.target;
        if (!t || window.__clnfDispatchingVariantChangeForApps) return;
        if (t.id === "AddToCartForm" || clnfEventIsProductOptionRadio(t)) {
          clnfScheduleVariantChangeForApps();
        }
      },
      true
    );
    // Swatch cards: Vue updates option/variant synchronously, but WeTheme's form `change`
    // does not always fire a native event apps can hear. After the click settles, tell
    // UpNova via the canonical select — never synthesize input/change on the radios.
    document.addEventListener(
      "click",
      function (ev) {
        var t = ev.target;
        if (!t || !t.closest || window.__clnfDispatchingVariantChangeForApps) return;
        if (!t.closest("#AddToCartForm .swatch-element")) return;
        clnfScheduleVariantChangeForApps();
      },
      true
    );
    document.addEventListener("shopify:section:load", function () {
      clnfLastVariantChangeDispatchedId = "";
      clnfScheduleVariantChangeForApps();
    });
  }
  clnfBindVariantChangeForApps();

  // slide arrow â€“ single source of truth: bullets or thumbnails (both trigger same media activation)
  // Re-query imageWarpper each time (Vue may mount after DOMContentLoaded)
  function getImageWrapper() {
    return document.querySelector(".images-product-wrapper");
  }
  let imageWarpper = getImageWrapper();
  var _gallerySyncFn = function () {};

  function ensurePdpGalleryPrimaryClass(wrapper) {
    if (!wrapper) return;
    if (wrapper.querySelector(".product-medias__main .swiper-slide.product-medias__primary")) return;
    var first = wrapper.querySelector(".product-medias__main .swiper-slide");
    if (first) first.classList.add("product-medias__primary");
  }

  function syncGalleryHeight() {
    var wrapper = getImageWrapper();
    if (!wrapper) return;
    const container = wrapper.querySelector(".product-medias__main .swiper-container");
    if (!container) return;
    ensurePdpGalleryPrimaryClass(wrapper);
    const activeSlide =
      wrapper.querySelector(".swiper-slide.product-medias__primary") ||
      wrapper.querySelector(".product-medias__main .swiper-slide");
    if (!activeSlide) return;
    let h = activeSlide.offsetHeight;
    if (h <= 0) {
      const img = activeSlide.querySelector("img");
      if (img && img.naturalHeight) h = img.naturalHeight;
    }
    if (h > 0) container.style.height = h + "px";
  }

  function bindGalleryImageLoad() {
    var wrapper = getImageWrapper();
    if (!wrapper) return;
    wrapper.querySelectorAll(".product-medias__main img").forEach(function (img) {
      if (img.dataset.heightBound) return;
      img.dataset.heightBound = "1";
      if (img.complete) syncGalleryHeight();
      else img.addEventListener("load", syncGalleryHeight, { once: true });
    });
  }

  function runGallerySync() {
    syncGalleryHeight();
    bindGalleryImageLoad();
  }
  if (getImageWrapper()) _gallerySyncFn = runGallerySync;

  // PDP thumbnail click fallback: always register (so it works even if .images-product-wrapper is missing at DOMContentLoaded)
  var thumbSelector = ".product-medias__thumbnail, .product_medias_thumbnail, .product-medias.thumbnail, a[href='#'][data-media-id], a[data-media-id].product-medias, a[data-media-id]";

  /**
   * clnf-product-pdp.css hides non-.product-medias__primary slides. WeTheme Swiper updates
   * activeIndex but does not toggle that class — sync after thumb, arrow, or slideChange.
   */
  function syncPdpPrimarySlideState(wrapper, activeIndex) {
    if (!wrapper) return;
    var slides = wrapper.querySelectorAll(".product-medias__main .swiper-slide");
    if (!slides.length) return;
    var idx = activeIndex;
    if (idx < 0 || idx >= slides.length) return;
    slides.forEach(function (slide, i) {
      var isActive = (i === idx);
      slide.classList.toggle("product-medias__primary", isActive);
      // Inline style is not reset by Vue's re-render (Vue only patches style on :style-bound nodes)
      slide.style.display = isActive ? "block" : "none";
    });
    var activeSlide = slides[idx];
    var mediaId = activeSlide.getAttribute("data-media-id");
    if (!mediaId) {
      var inner = activeSlide.querySelector(".product-medias__media[data-media-id], [data-media-id]");
      if (inner) mediaId = inner.getAttribute("data-media-id");
    }
    var thumbs = wrapper.querySelectorAll(thumbSelector);
    thumbs.forEach(function (t) {
      var mid = t.getAttribute("data-media-id");
      t.classList.toggle("product-single_media--selected", !!(mediaId && mid === mediaId));
    });
    setTimeout(_gallerySyncFn, 50);
  }

  function getVariantFeaturedMediaId(variantId) {
    var product = getParsedProductJsonForClp();
    if (!product || !Array.isArray(product.variants) || !variantId) return null;
    var selected = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(variantId)) {
        selected = product.variants[i];
        break;
      }
    }
    if (!selected) return null;
    if (selected.featured_media && selected.featured_media.id) {
      return String(selected.featured_media.id);
    }
    if (selected.featured_image && selected.featured_image.id) {
      return String(selected.featured_image.id);
    }
    return null;
  }

  function resetPdpGallerySwiperOffset(wrapper) {
    if (!wrapper) return;
    var container = wrapper.querySelector(".product-medias__main .swiper-container");
    var swWrapper = container && container.querySelector(".swiper-wrapper");
    if (swWrapper) {
      swWrapper.style.transitionDuration = "0ms";
      swWrapper.style.transform = "translate3d(0px,0px,0px)";
    }
    if (container && container.swiper) {
      try { container.swiper.translate = 0; } catch (_) {}
      try { container.swiper.previousTranslate = 0; } catch (_) {}
    }
  }

  function syncPdpGalleryToSelectedVariant() {
    var wrapper = getImageWrapper();
    if (!wrapper) return false;
    var mediaId = getVariantFeaturedMediaId(resolveSelectedVariantIdForClp());
    if (!mediaId) return false;

    var slides = wrapper.querySelectorAll(".product-medias__main .swiper-slide");
    for (var i = 0; i < slides.length; i++) {
      var slideMediaId = slides[i].getAttribute("data-media-id");
      if (!slideMediaId) {
        var inner = slides[i].querySelector(".product-medias__media[data-media-id], [data-media-id]");
        if (inner) slideMediaId = inner.getAttribute("data-media-id");
      }
      if (String(slideMediaId) === mediaId) {
        syncPdpPrimarySlideState(wrapper, i);
        resetPdpGallerySwiperOffset(wrapper);
        return true;
      }
    }
    return false;
  }

  var _clnfPdpVariantGallerySyncTimer = null;
  function schedulePdpGalleryVariantSync() {
    window.requestAnimationFrame(syncPdpGalleryToSelectedVariant);
    if (_clnfPdpVariantGallerySyncTimer) {
      clearTimeout(_clnfPdpVariantGallerySyncTimer);
    }
    _clnfPdpVariantGallerySyncTimer = setTimeout(function () {
      _clnfPdpVariantGallerySyncTimer = null;
      syncPdpGalleryToSelectedVariant();
    }, 120);
  }

  function bindPdpGalleryVariantSync() {
    var form = document.getElementById("AddToCartForm");
    if (form && form.dataset.clnfGalleryVariantBound !== "1") {
      form.dataset.clnfGalleryVariantBound = "1";
      form.addEventListener(
        "change",
        function (ev) {
          var t = ev.target;
          var nm = (t && t.name && String(t.name).toLowerCase()) || "";
          if (nm === "quantity" || nm.indexOf("updates") === 0) return;
          schedulePdpGalleryVariantSync();
        },
        { passive: true }
      );
    }

    if (bindPdpGalleryVariantSync._documentBound) return;
    bindPdpGalleryVariantSync._documentBound = true;
    document.addEventListener(
      "click",
      function (e) {
        if (!e.target || !e.target.closest) return;
        if (!e.target.closest("#AddToCartForm .swatch-element")) return;
        schedulePdpGalleryVariantSync();
      },
      true
    );
  }

  function tryBindProductMediaSwiperSlideSync() {
    var wrapper = getImageWrapper();
    if (!wrapper) return false;
    var container = wrapper.querySelector(".product-medias__main .swiper-container");
    if (!container || !container.swiper) return false;
    if (container._clnfSwiperSlideSyncBound) return true;
    container._clnfSwiperSlideSyncBound = true;
    var sw = container.swiper;
    try { sw.update(); } catch (_) {}
    sw.on("slideChange", function () {
      syncPdpPrimarySlideState(wrapper, sw.activeIndex);
    });
    syncPdpPrimarySlideState(wrapper, sw.activeIndex);
    return true;
  }

  var _clnfSwiperBindTries = 0;
  function scheduleProductMediaSwiperSyncBind() {
    if (tryBindProductMediaSwiperSlideSync()) {
      _clnfSwiperBindTries = 0;
      return;
    }
    if (++_clnfSwiperBindTries > 60) return;
    setTimeout(scheduleProductMediaSwiperSyncBind, 100);
  }

  function activateProductMediaByThumb(thumb) {
    var wrapper = thumb.closest(".images-product-wrapper") || thumb.closest(".product-single") || thumb.closest(".product-form-vue") || thumb.closest(".product-images-container");
    if (!wrapper) return false;
    var thumbnails = wrapper.querySelectorAll(thumbSelector);
    var slides = wrapper.querySelectorAll(".product-medias__main .swiper-slide, .swiper-container .swiper-slide");
    var mediaId = thumb.getAttribute("data-media-id");
    var thumbIndex = Array.from(thumbnails).indexOf(thumb);
    if (thumbIndex < 0) return false;

    var slideIndex = -1;
    if (mediaId && slides.length > 0) {
      for (var i = 0; i < slides.length; i++) {
        var el = slides[i];
        if (el.getAttribute("data-media-id") === mediaId || el.querySelector("[data-media-id='" + mediaId + "']")) {
          slideIndex = i;
          break;
        }
      }
    }
    
    if (slideIndex < 0) {
      slideIndex = thumbIndex;
    }

    if (slides.length > 0) {
      if (slideIndex >= slides.length) return false;
      var container = wrapper.querySelector(".product-medias__main .swiper-container, .swiper-container");
      syncPdpPrimarySlideState(wrapper, slideIndex);
      // Reset swiper wrapper transform – direct DOM, survives any Swiper API version
      var swWrapper = container && container.querySelector(".swiper-wrapper");
      if (swWrapper) {
        swWrapper.style.transitionDuration = "0ms";
        swWrapper.style.transform = "translate3d(0px,0px,0px)";
      }
      if (container && container.swiper) {
        try { container.swiper.translate = 0; } catch (_) {}
        try { container.swiper.previousTranslate = 0; } catch (_) {}
      }
    } else if (mediaId) {
      var mediaItems = wrapper.querySelectorAll(".product-medias__main [data-media-id], .swiper-slide [data-media-id], .product-medias__media[data-media-id]");
      mediaItems.forEach(function (el) {
        var active = el.getAttribute("data-media-id") === mediaId;
        el.classList.toggle("product-medias__primary", active);
        el.classList.toggle("product-medias__media--active", active);
        var slide = el.closest(".swiper-slide");
        if (slide) slide.classList.toggle("product-medias__primary", active);
      });
    } else {
      return false;
    }
    return true;
  }
  function onThumbClick(e) {
    if (e.target.closest(".swatch-items-wrapper")) return;
    var thumb = e.target.closest(thumbSelector);
    if (!thumb) return;
    // thumbSelector includes bare `a[data-media-id]` — ignore matches outside the PDP gallery column
    // so unrelated links in .product-single never get preventDefault (intermittent variant/price bugs).
    if (!thumb.closest(".images-product-wrapper") && !thumb.closest(".product-images-container")) return;
    if (activateProductMediaByThumb(thumb)) {
      e.preventDefault();
    }
  }
  function onThumbKeydown(e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    if (e.target.closest(".swatch-items-wrapper")) return;
    var thumb = e.target.closest(thumbSelector);
    if (!thumb) return;
    if (!thumb.closest(".images-product-wrapper") && !thumb.closest(".product-images-container")) return;
    if (activateProductMediaByThumb(thumb)) {
      e.preventDefault();
    }
  }
  document.addEventListener("click", onThumbClick, true);
  document.addEventListener("keydown", onThumbKeydown, true);

  // Expose for inline script in product-media.liquid (direct thumbnail handlers)
  window.__activateProductMediaByThumb = activateProductMediaByThumb;

  function bindThumbnailsDirect() {
    document.querySelectorAll('.product-images-container a[data-media-id]:not([data-pdp-thumb-bound])').forEach(function(a) {
      a.setAttribute('data-pdp-thumb-bound', '1');
      a.addEventListener('click', function(e) {
        e.preventDefault();
        activateProductMediaByThumb(a);
      });
      a.addEventListener('keydown', function(e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        activateProductMediaByThumb(a);
      });
    });
  }
  bindThumbnailsDirect();
  window.addEventListener('load', bindThumbnailsDirect);

  /**
   * Step gallery by slide index (not slideNext/slidePrev) so it stays aligned with
   * display:none on non-.product-medias__primary slides.
   */
  function navigateGallery(direction) {
    var wrapper = getImageWrapper();
    if (!wrapper) return;

    var slides = wrapper.querySelectorAll(".product-medias__main .swiper-slide");
    if (!slides || slides.length <= 1) return;

    var n = slides.length;
    var currentIndex = -1;
    for (var si = 0; si < n; si++) {
      if (slides[si].classList && slides[si].classList.contains("product-medias__primary")) {
        currentIndex = si;
        break;
      }
    }
    if (currentIndex < 0) currentIndex = 0;

    var newIndex =
      direction === "next"
        ? (currentIndex + 1) % n
        : (currentIndex - 1 + n) % n;

    syncPdpPrimarySlideState(wrapper, newIndex);

    var container = wrapper.querySelector(".product-medias__main .swiper-container");
    var swWrapper = container && container.querySelector(".swiper-wrapper");
    if (swWrapper) {
      swWrapper.style.transitionDuration = "0ms";
      swWrapper.style.transform = "translate3d(0px,0px,0px)";
    }
    if (container && container.swiper) {
      try { container.swiper.translate = 0; } catch (_) {}
      try { container.swiper.previousTranslate = 0; } catch (_) {}
    }

    setTimeout(syncGalleryHeight, 150);
  }

  /**
   * Vue (wetheme-product-form inline-template) replaces the product column DOM after mount.
   * Listeners on .images-product-wrapper from DOMContentLoaded attach to detached nodes.
   * Thumbnails still work because onThumbClick uses document capture â€” match that for arrows/zoom.
   */
  function bindPdpGalleryArrowDelegation() {
    if (bindPdpGalleryArrowDelegation._done) return;
    bindPdpGalleryArrowDelegation._done = true;

    function resolvePdpArrowTarget(e) {
      var t = e.target;
      if (!t || typeof t.closest !== "function") return null;
      return (
        t.closest(".flex-next") ||
        t.closest(".flex-prev") ||
        t.closest("[data-pdp-gallery='next']") ||
        t.closest("[data-pdp-gallery='prev']")
      );
    }

    function arrowDirectionFromEl(el) {
      if (!el) return null;
      var g = el.getAttribute("data-pdp-gallery");
      if (g === "next" || el.classList.contains("flex-next")) return "next";
      if (g === "prev" || el.classList.contains("flex-prev")) return "prev";
      return null;
    }

    document.addEventListener(
      "click",
      function (e) {
        var el = resolvePdpArrowTarget(e);
        if (!el) return;
        if (!e.target.closest || !e.target.closest(".images-product-wrapper")) return;
        e.preventDefault();
        var dir = arrowDirectionFromEl(el);
        if (dir) navigateGallery(dir);
      },
      true
    );

    document.addEventListener(
      "keydown",
      function (e) {
        if (e.key !== "Enter" && e.key !== " ") return;
        var el = resolvePdpArrowTarget(e);
        if (!el) return;
        if (!e.target.closest || !e.target.closest(".images-product-wrapper")) return;
        e.preventDefault();
        var dir = arrowDirectionFromEl(el);
        if (dir) navigateGallery(dir);
      },
      true
    );

    document.addEventListener(
      "click",
      function (e) {
        var zoom = e.target.closest(".images-product-wrapper .imzoom");
        if (!zoom) return;
        var fancyImg = document.querySelector(
          ".images-product-wrapper .products-images img:first-child"
        );
        if (fancyImg) fancyImg.click();
      },
      true
    );
  }

  bindPdpGalleryArrowDelegation();

  document.addEventListener(
    "click",
    function (e) {
      if (!e.target.closest || !e.target.closest(".images-product-wrapper .swiper-pagination-bullet")) return;
      var wrapper = getImageWrapper();
      if (!e.target.closest(".images-product-wrapper") || !wrapper) return;
      setTimeout(function () {
        var c = wrapper.querySelector(".product-medias__main .swiper-container");
        if (c && c.swiper) syncPdpPrimarySlideState(wrapper, c.swiper.activeIndex);
      }, 0);
    },
    true
  );

  function initProductGallery() {
    var wrapper = getImageWrapper();
    if (!wrapper) return;

    bindPdpGalleryVariantSync();
    scheduleProductMediaSwiperSyncBind();
    runGallerySync();
    schedulePdpGalleryVariantSync();
    [100, 200, 400, 800].forEach(function (ms) {
      setTimeout(function () {
        runGallerySync();
        syncPdpGalleryToSelectedVariant();
      }, ms);
    });
    var main = wrapper.querySelector(".product-medias__main");
    if (main) {
      if (_clnfGalleryHeightObs) { _clnfGalleryHeightObs.disconnect(); _clnfGalleryHeightObs = null; }
      var heightSyncTimer = 0;
      _clnfGalleryHeightObs = new MutationObserver(function () {
        if (heightSyncTimer) clearTimeout(heightSyncTimer);
        heightSyncTimer = setTimeout(function () {
          heightSyncTimer = 0;
          runGallerySync();
        }, 100);
      });
      _clnfGalleryHeightObs.observe(main, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }

  initProductGallery();
  window.addEventListener("load", function () {
    runGallerySync();
    initProductGallery();
  });
  var galleryRetryCount = 0;
  var galleryRetryInterval = setInterval(function () {
    galleryRetryCount++;
    if (galleryRetryCount > 25) {
      clearInterval(galleryRetryInterval);
      return;
    }
    var wrapper = getImageWrapper();
    if (wrapper && wrapper.querySelectorAll(".swiper-slide").length > 0) {
      clearInterval(galleryRetryInterval);
      runGallerySync();
    }
  }, 200);

  let getthnotify = document.querySelector(
    '[id^="shopify-block-pw_stock_notify_app_block_"]'
  );

  function getSwatchInputFromEventTarget(target, currentSwatchEle) {
    if (!currentSwatchEle) return null;
    var t = target && target.nodeType === 1 ? target : null;
    if (!t) return null;
    if (t.matches && t.matches("input[type='radio']")) return t;
    if (t.matches && t.matches("label[for]")) {
      var inputId = t.getAttribute("for");
      if (inputId) {
        var fromLabel = null;
        if (typeof CSS !== "undefined" && CSS.escape) {
          fromLabel = currentSwatchEle.querySelector("#" + CSS.escape(inputId));
        }
        if (!fromLabel) {
          fromLabel = document.getElementById(inputId);
          if (fromLabel && !currentSwatchEle.contains(fromLabel)) fromLabel = null;
        }
        if (fromLabel) return fromLabel;
      }
    }
    return currentSwatchEle.querySelector("input[type='radio']");
  }

  function dispatchSwatchInputEvent(input, type) {
    if (!input) return;
    var event;
    if (typeof Event === "function") {
      event = new Event(type, { bubbles: true });
    } else {
      event = document.createEvent("Event");
      event.initEvent(type, true, false);
    }
    input.dispatchEvent(event);
  }

  function isNativeSwatchActivationTarget(target, swatchInput) {
    if (!target || !swatchInput || target === swatchInput) return true;
    var fid = swatchInput.id;
    if (!fid) return false;
    // Clicks on text/icons inside <label for="..."> must use native activation only — synthetic
    // input/change + browser label routing double-fire Vue and price stops updating after a few picks.
    var lbl = target.closest ? target.closest("label[for]") : null;
    if (lbl && lbl.getAttribute("for") === fid) return true;
    if (target.matches && target.matches("label[for]") && target.getAttribute("for") === fid) return true;
    return false;
  }

  function activateSwatchInputFromTileClick(target, swatchInput) {
    if (!swatchInput || isNativeSwatchActivationTarget(target, swatchInput)) {
      return false;
    }
    if (swatchInput.checked) return false;
    swatchInput.checked = true;
    dispatchSwatchInputEvent(swatchInput, "input");
    dispatchSwatchInputEvent(swatchInput, "change");
    return true;
  }

  let paymentButtonsWrapperonload = document.querySelector(".form-vertical");
  // console.log(paymentButtonsWrapperonload,'paymentButtonsWrapperonload')
  let getaddtocart = getPrimaryProductAtcButton();
  var onloadnotifyDiv = getActiveOnloadNotifyContainer();
  let notifyButton = findNotifyTriggerButton();

  // Utility: toggle visibility for all Add to Cart buttons (desktop + mobile)
  function setAddToCartVisibility(show) {
    const atcButtons = queryAllProductAtcButtons();
    const notifyButtons = document.querySelectorAll("#pw_notify_popup_open");
    atcButtons.forEach((btn) => {
      if (!btn) return;
      if (show) {
        btn.style.setProperty("display", "", "important");
        btn.style.setProperty("visibility", "", "important");
        btn.style.setProperty("opacity", "", "important");
        btn.style.setProperty("position", "", "important");
        btn.style.setProperty("pointer-events", "", "important");
        btn.style.setProperty("z-index", "", "important");
        btn.style.setProperty("width", "", "important");
        btn.style.setProperty("margin", "", "important");
        btn.removeAttribute("aria-hidden");
      } else {
        btn.style.setProperty("display", "none", "important");
        btn.style.setProperty("pointer-events", "none", "important");
        btn.style.setProperty("position", "absolute", "important");
        btn.style.setProperty("visibility", "hidden", "important");
        btn.style.setProperty("opacity", "0", "important");
        btn.style.setProperty("z-index", "-1", "important");
        btn.setAttribute("aria-hidden", "true");
      }
    });
    // When showing Add to Cart, ensure notify is fully hidden and non-interactive
    if (show && notifyButtons.length) {
      notifyButtons.forEach((btn) => {
        btn.style.setProperty("display", "none", "important");
        btn.style.setProperty("visibility", "hidden", "important");
        btn.style.setProperty("opacity", "0", "important");
        btn.style.setProperty("position", "absolute", "important");
        btn.style.setProperty("pointer-events", "none", "important");
        btn.style.setProperty("z-index", "-1", "important");
        btn.style.setProperty("width", "0", "important");
        btn.style.setProperty("height", "0", "important");
        btn.style.setProperty("padding", "0", "important");
        btn.style.setProperty("margin", "0", "important");
        btn.setAttribute("aria-hidden", "true");
        btn.classList.add("hidden-notify-button");
      });
    }
  }

  function getSelectedVariantOption() {
    return document.querySelector(".product-single__variants option:checked");
  }

  function getProductJsonScriptEl() {
    return (
      document.querySelector('script.product-json[type="application/json"]') ||
      document.querySelector('script[type="application/json"].product-json') ||
      document.querySelector('[id^="ProductJson-"][type="application/json"]')
    );
  }

  function getParsedProductJsonForClp() {
    if (clnfCachedProductForClp !== undefined) return clnfCachedProductForClp;
    var el = getProductJsonScriptEl();
    if (!el) {
      clnfCachedProductForClp = null;
      return null;
    }
    try {
      clnfCachedProductForClp = JSON.parse(el.textContent);
    } catch (_) {
      clnfCachedProductForClp = null;
      return null;
    }
    return clnfCachedProductForClp;
  }

  /** Matches WeTheme: product JSON in template â€” availability does not depend on Vue v-if timing or hidden ATC. */
  function getSelectedVariantAvailableFromProductJson() {
    const product = getParsedProductJsonForClp();
    if (!product || !Array.isArray(product.variants)) return null;

    let vid = null;
    // select.product-single__variants is Vue's source of truth and updates immediately on variant
    // change; input[name="id"] lags behind by a tick (WeTheme timing race) — always prefer select.
    const select = document.querySelector(".product-single__variants");
    if (select && select.value) vid = parseInt(String(select.value), 10);
    if (!vid && select && select.options && select.options.length) {
      const opt = select.querySelector("option:checked");
      if (opt) vid = parseInt(String(opt.value), 10);
    }
    if (!vid) {
      const hiddenId = document.querySelector('#AddToCartForm input[name="id"]');
      if (hiddenId && hiddenId.value) vid = parseInt(String(hiddenId.value), 10);
    }
    if (!vid) return null;
    const v = product.variants.find(function (x) {
      return Number(x.id) === vid;
    });
    if (!v || typeof v.available === "undefined") return null;
    return v.available === true;
  }

  /**
   * Selected variant id for CLP points: prefer form line item id (Vue truth), then select.
   * Matches what gets submitted with Add to cart.
   */
  function resolveSelectedVariantIdForClp() {
    // select.product-single__variants is Vue's source of truth and updates immediately on variant
    // change; input[name="id"] lags behind by a tick (WeTheme timing race) — always prefer select.
    const select = document.querySelector(".product-single__variants");
    if (select && select.value) {
      const parsed = parseInt(String(select.value), 10);
      if (!isNaN(parsed)) return parsed;
    }
    if (select && select.options && select.options.length) {
      const opt = select.querySelector("option:checked");
      if (opt) {
        const parsed = parseInt(String(opt.value), 10);
        if (!isNaN(parsed)) return parsed;
      }
    }
    const hiddenId = document.querySelector('#AddToCartForm input[name="id"]');
    if (hiddenId && hiddenId.value) {
      const parsed = parseInt(String(hiddenId.value), 10);
      if (!isNaN(parsed)) return parsed;
    }
    return null;
  }

  /** Variant object from embedded product JSON for the current DOM selection (client-side price). */
  function getSelectedVariantFromProductJson() {
    const product = getParsedProductJsonForClp();
    if (!product || !Array.isArray(product.variants)) return null;
    const vid = resolveSelectedVariantIdForClp();
    if (!vid) return null;
    return (
      product.variants.find(function (x) {
        return Number(x.id) === vid;
      }) || null
    );
  }

  /**
   * clp-points-earned-box.liquid renders points from selected_or_first_available_variant only.
   * Recalculate when the shopper changes variant (Vue does not re-render this block).
   */
  function applyClpPointsForPriceCents(priceCents) {
    const roots = document.querySelectorAll("[data-clp-points-earned-root]");
    if (!roots.length || typeof priceCents !== "number") return;

    const dollars = priceCents / 100;

    for (let ri = 0; ri < roots.length; ri++) {
      const root = roots[ri];
      const mult = parseInt(String(root.getAttribute("data-multiplier") || "0"), 10);
      const safeMult = isNaN(mult) ? 0 : mult;

      const earnedEl = root.querySelector(".clp-points-earned-value");
      const guestEl = root.querySelector(".clp-points-guest-value");

      if (safeMult > 0 && earnedEl) {
        earnedEl.textContent = String(Math.round(dollars * safeMult));
      } else if (safeMult === 0 && guestEl) {
        guestEl.textContent = String(Math.round(dollars));
      }
    }
  }

  function syncClpPointsEarnedBox() {
    const variant = getSelectedVariantFromProductJson();
    if (!variant || typeof variant.price !== "number") return;
    applyClpPointsForPriceCents(variant.price);
  }

  /**
   * Country Life Plus points (custom Liquid): WeTheme applies the new variant, then fires a native
   * "change" on #AddToCartForm. After the immediate sync we also poll for up to 3 s so that if
   * WeTheme updates input[name="id"] slightly after the change event (timing race), we still catch
   * the new variant and refresh the display without waiting for the next user interaction.
   */
  function clnfScheduleClpPointsSync() {
    syncClpPointsEarnedBox();
    requestAnimationFrame(syncClpPointsEarnedBox);

    if (clnfClpVariantPollTimer) {
      clearInterval(clnfClpVariantPollTimer);
      clnfClpVariantPollTimer = null;
    }
    var pollN = 0;
    var pollLastId = resolveSelectedVariantIdForClp();
    clnfClpVariantPollTimer = setInterval(function () {
      var id = resolveSelectedVariantIdForClp();
      if (id && id !== pollLastId) {
        pollLastId = id;
        syncClpPointsEarnedBox();
      }
      if (++pollN >= 30) {
        clearInterval(clnfClpVariantPollTimer);
        clnfClpVariantPollTimer = null;
      }
    }, 100);
  }

  /**
   * Bound on `document`, not on `#AddToCartForm` itself: WeTheme's Vue inline-template mount
   * replaces the form node after DOMContentLoaded, which orphans listeners attached directly to
   * it (and bakes any pre-mount `data-*` "already bound" flag into the compiled render function,
   * so the replacement node comes back flagged bound while carrying no listeners) — see the
   * `clnfBindHardVariantSubmitGuard` / `clnfBindCcCardSelectedStateSync` pattern above. Resolve
   * the form via `closest("#AddToCartForm")` at event time so this keeps working after Vue swaps
   * the node, instead of closing over the pre-mount reference.
   */
  function clnfBindClpPointsEarnedBoxSync() {
    if (window.__clnfClpPointsSyncBound) return;
    window.__clnfClpPointsSyncBound = true;

    document.addEventListener(
      "change",
      function (ev) {
        var t = ev.target;
        if (!t || !t.closest || !t.closest("#AddToCartForm")) return;
        var nm = (t.name && String(t.name).toLowerCase()) || "";
        if (nm === "quantity" || nm.indexOf("updates") === 0) return;

        clnfScheduleClpPointsSync();
      },
      { passive: true }
    );

    document.addEventListener(
      "click",
      function (e) {
        if (!e.target || !e.target.closest) return;
        if (!e.target.closest("#AddToCartForm") || !e.target.closest(".swatch-element")) return;
        requestAnimationFrame(clnfScheduleClpPointsSync);
      },
      true
    );
  }

  clnfBindClpPointsEarnedBoxSync();

  function getSwatchOutOfStockState() {
    const currentSwatch = document.querySelector(".swatch-element input:checked");
    const swatchElement = currentSwatch?.closest(".swatch-element");
    if (!swatchElement) return null;

    if (swatchElement.classList.contains("soldout")) {
      return true;
    }

    const dataStatus = swatchElement.getAttribute("data-status");
    if (dataStatus === "false") {
      return true;
    }

    return false;
  }

  /**
   * Read ATC stock from DOM for every .js-product-atc-btn, including when our notify script
   * has set display:none â€” otherwise we misread "in stock" from the <select> and flip-flop,
   * leaving a blank buy area while Vue updates.
   * Prefer "unavailable" if any button disagrees (notify safer than hiding both CTAs).
   */
  function getAggregatedAtcDomStockState() {
    const atcButtons = queryAllProductAtcButtons();
    if (!atcButtons.length) return "unknown";

    let sawAvailable = false;
    let sawUnavailable = false;

    for (const atc of atcButtons) {
      if (atc.querySelector(".fa-spin, .fa-circle-o-notch.fa-spin")) {
        continue;
      }
      if (atc.querySelector(".soldoutbtn")) {
        sawUnavailable = true;
        continue;
      }
      const text = (atc.textContent || "").trim().toLowerCase();
      const isSoldOut =
        text.includes("sold out") ||
        text.includes("out of stock") ||
        text.includes("unavailable");
      const isDisabled = atc.disabled || atc.classList.contains("disabled");

      if (isSoldOut || isDisabled) {
        sawUnavailable = true;
        continue;
      }

      if (text.length > 0) {
        sawAvailable = true;
      }
    }

    if (sawUnavailable) return "unavailable";
    if (sawAvailable) return "available";
    return "unknown";
  }

  // Resolve stock: Liquid/JSON variant data first, then DOM (Vue can lag behind late listeners).
  function resolveOutOfStockState() {
    const selectedVariantOption = getSelectedVariantOption();
    const swatchOutOfStock = getSwatchOutOfStockState();
    const atcDom = getAggregatedAtcDomStockState();
    const jsonAvailable = getSelectedVariantAvailableFromProductJson();

    let branch = "";
    let result = true;

    if (selectedVariantOption && selectedVariantOption.disabled) {
      branch = "option_disabled";
      result = true;
    } else if (jsonAvailable === false) {
      branch = "json_false";
      result = true;
    } else if (swatchOutOfStock === true) {
      branch = "swatch_oos";
      result = true;
    } else if (jsonAvailable === true) {
      branch = "json_true";
      result = false;
    } else if (atcDom === "unavailable") {
      branch = "atc_dom_unavailable";
      result = true;
    } else if (atcDom === "available") {
      branch = "atc_dom_available";
      result = false;
    } else if (selectedVariantOption && !selectedVariantOption.disabled) {
      branch = "option_enabled_fallback";
      result = false;
    } else if (swatchOutOfStock === false) {
      branch = "swatch_in_stock_fallback";
      result = false;
    } else {
      branch = "default_assume_in_stock";
      result = false;
    }

    return result;
  }

  // Immediately hide notify button on discovery to prevent flash
  function hideNotifyButtonImmediately(button) {
    if (!button) return;
    button.classList.add("hidden-notify-button");
    button.style.setProperty("display", "none", "important");
    button.style.setProperty("visibility", "hidden", "important");
    button.style.setProperty("opacity", "0", "important");
    button.style.setProperty("position", "absolute", "important");
    button.style.setProperty("pointer-events", "none", "important");
    button.style.setProperty("z-index", "-1", "important");
    button.style.setProperty("width", "0", "important");
    button.style.setProperty("height", "0", "important");
    button.style.setProperty("padding", "0", "important");
    button.style.setProperty("margin", "0", "important");
    button.style.setProperty("overflow", "hidden", "important");
    button.setAttribute("aria-hidden", "true");
  }

  // Hide button immediately if it exists on page load
  if (notifyButton) {
    hideNotifyButtonImmediately(notifyButton);
  }

  /** Plain-text fallback link: show when OOS and PW trigger is missing or still hidden. */
  function syncPwNotifyTextFallback() {
    var els = document.querySelectorAll(".pw-notify-fallback-text");
    if (!els.length) return;
    var oos = resolveOutOfStockState();
    var trig = findNotifyTriggerButton();
    var trigUsable = false;
    if (oos && trig && !trig.classList.contains("hidden-notify-button")) {
      var cs = window.getComputedStyle(trig);
      if (cs.display !== "none" && cs.visibility !== "hidden" && parseFloat(cs.opacity || "1") > 0) {
        var rect = trig.getBoundingClientRect();
        trigUsable = rect.width > 2 && rect.height > 2;
      }
    }
    els.forEach(function (el) {
      if (oos && !trigUsable) el.classList.remove("pw-notify-fallback-text--conceal");
      else el.classList.add("pw-notify-fallback-text--conceal");
    });
  }

  // Function to attach click handler to notify button
  function attachNotifyButtonClickHandler(button) {
    if (!button) return button;

    // If handler already attached, don't re-attach (prevents infinite loop)
    if (button.hasAttribute('data-click-handler-attached')) {
      return button;
    }

    // Attach click handler directly (no cloning to preserve element and prevent loop)
    button.addEventListener('click', function (e) {
      e.preventDefault();
      openPwStockNotifyModal();
    }, { once: false, passive: false });

    button.setAttribute('data-click-handler-attached', 'true');

    return button;
  }

  // Track PW notify button load: increment ONLY inside the scheduled timeout. Debounced
  // checkAndUpdateNotifyButton() can fire many times per second â€” incrementing here caused
  // MAX_RETRIES to burn in ~1s and repeated fallback â†” OOS toggles (Sold out "jumping").
  let notifyButtonRetryCount = 0;
  let notifyButtonRetryTimer = null;
  let notifyRetryLastVariantId = "";
  /** After MAX_RETRIES without #pw_notify_popup_open, keep ATC visible and text fallback until variant changes. */
  let notifyAppLoadGivenUp = false;
  const MAX_RETRIES = 32; // PW app can be slow on cold load (~16s at 500ms)

  function clearNotifyButtonRetrySchedule() {
    if (notifyButtonRetryTimer) {
      clearTimeout(notifyButtonRetryTimer);
      notifyButtonRetryTimer = null;
    }
  }

  function getCurrentVariantIdForNotify() {
    // select.product-single__variants is Vue's source of truth and updates immediately on variant
    // change; input[name="id"] lags behind by a tick (WeTheme timing race) — always prefer select.
    const sel = document.querySelector(".product-single__variants");
    if (sel && sel.value) return String(sel.value);
    const hiddenId = document.querySelector('#AddToCartForm input[name="id"]');
    return hiddenId && hiddenId.value ? String(hiddenId.value) : "";
  }

  let notifyVariantFollowUpGen = 0;

  /** Collapse many rapid stock checks (form change, observer, load) into one pass to reduce flicker. */
  let notifyUpdateDebounceTimer = null;
  const NOTIFY_UPDATE_DEBOUNCE_MS = 100;
  function scheduleNotifyUpdateImmediate() {
    if (notifyUpdateDebounceTimer) clearTimeout(notifyUpdateDebounceTimer);
    notifyUpdateDebounceTimer = null;
    checkAndUpdateNotifyButton();
  }
  function scheduleNotifyUpdate() {
    if (notifyUpdateDebounceTimer) clearTimeout(notifyUpdateDebounceTimer);
    notifyUpdateDebounceTimer = setTimeout(function () {
      notifyUpdateDebounceTimer = null;
      checkAndUpdateNotifyButton();
    }, NOTIFY_UPDATE_DEBOUNCE_MS);
  }

  // Function to toggle buttons based on stock status
  function toggleButtonsForStock(isOutOfStock) {
    const variantIdNow = getCurrentVariantIdForNotify();
    if (variantIdNow && variantIdNow !== notifyRetryLastVariantId) {
      notifyRetryLastVariantId = variantIdNow;
      clearNotifyButtonRetrySchedule();
      notifyButtonRetryCount = 0;
      notifyAppLoadGivenUp = false;
    }
    // Re-query elements in case they've changed
    notifyButton = findNotifyTriggerButton();
    getaddtocart = getPrimaryProductAtcButton();
    onloadnotifyDiv = getNotifyMountContainer();

    if (isOutOfStock) {
      if (notifyAppLoadGivenUp && !notifyButton) {
        document.body.classList.remove("notify-active");
        setAddToCartVisibility(true);
        syncPwNotifyTextFallback();
        return;
      }

      document.body.classList.add('notify-active');
      // Only hide add to cart button if app notify button exists
      if (notifyButton && onloadnotifyDiv) {
        // Hide all add to cart buttons and prevent them from blocking clicks
        setAddToCartVisibility(false);

        // Remove hidden class to show the button
        notifyButton.classList.remove('hidden-notify-button');
        // Only reparent when needed. PW block embedded in .paymentButtonsWrapper (Liquid) should stay put â€” Vue patches
        // can drop nodes that were moved from their original shopify-block subtree.
        if (onloadnotifyDiv && notifyButton.parentNode !== onloadnotifyDiv) {
          if (notifyButton.parentNode) notifyButton.parentNode.removeChild(notifyButton);
          onloadnotifyDiv.appendChild(notifyButton);
        }
        // Attach click handler to open popup (app's handler breaks when button is moved)
        if (!notifyButton.hasAttribute('data-click-handler-attached')) {
          notifyButton = attachNotifyButtonClickHandler(notifyButton);
          notifyButton.setAttribute('data-click-handler-attached', 'true');
        }
        // Ensure visibility with !important to override CSS hide rule
        notifyButton.style.setProperty('display', 'inline-block', 'important');
        notifyButton.style.setProperty('visibility', 'visible', 'important');
        notifyButton.style.setProperty('opacity', '1', 'important');
        notifyButton.style.setProperty('z-index', '10', 'important');
        notifyButton.style.setProperty('pointer-events', 'auto', 'important');
        notifyButton.style.setProperty('position', 'relative', 'important');
        notifyButton.style.setProperty('left', 'auto', 'important');
        notifyButton.style.setProperty('right', 'auto', 'important');
        notifyButton.style.setProperty('top', 'auto', 'important');
        notifyButton.style.setProperty('bottom', 'auto', 'important');
        notifyButton.style.width = "100%";
        notifyButton.style.minHeight = "44px";
        notifyButton.style.padding = "";
        notifyButton.style.margin = "";
        notifyButton.style.overflow = "";
        notifyButton.removeAttribute('aria-hidden');

        // Reset retry count on success
        notifyButtonRetryCount = 0;
        notifyAppLoadGivenUp = false;
        clearNotifyButtonRetrySchedule();
      } else if (onloadnotifyDiv && !notifyButton) {
        // If button doesn't exist yet, keep retrying (but don't hide Add to Cart yet).
        // One pending timeout only â€” do not increment on every debounced stock check.
        if (notifyButtonRetryCount >= MAX_RETRIES) {
          clearNotifyButtonRetrySchedule();
          notifyAppLoadGivenUp = true;
          document.body.classList.remove("notify-active");
          setAddToCartVisibility(true);
          notifyButtonRetryCount = 0;
        } else if (!notifyButtonRetryTimer) {
          notifyButtonRetryTimer = setTimeout(function () {
            notifyButtonRetryTimer = null;
            notifyButtonRetryCount++;
            toggleButtonsForStock(true);
          }, 500);
        }
      } else {
        clearNotifyButtonRetrySchedule();
        notifyAppLoadGivenUp = true;
        document.body.classList.remove("notify-active");
        setAddToCartVisibility(true);
        notifyButtonRetryCount = 0;
      }
    } else {
      clearNotifyButtonRetrySchedule();
      notifyButtonRetryCount = 0;
      notifyAppLoadGivenUp = false;
      document.body.classList.remove('notify-active');
      // In stock - show add to cart button
      setAddToCartVisibility(true);
      // Hide ALL notify buttons - use multiple methods to ensure they're hidden
      const allNotifyButtons = document.querySelectorAll("#pw_notify_popup_open");
      allNotifyButtons.forEach(function (btn) {
        hideNotifyButtonImmediately(btn);
      });
      // Update the notifyButton variable if it exists
      if (notifyButton) {
        notifyButton = null;
      }
    }
    syncPwNotifyTextFallback();
  }

  // Function to check and update button visibility based on current variant
  function checkAndUpdateNotifyButton() {
    // Mark body as ready after first stock check - allows CSS to show button if needed
    if (!document.body.classList.contains('notify-ready')) {
      document.body.classList.add('notify-ready');
    }

    const isOutOfStock = resolveOutOfStockState();

    toggleButtonsForStock(isOutOfStock);
  }

  function scheduleNotifyCheckAfterVariantChange() {
    // Same signals WeTheme / PW notify use (variant:* events + form change). Points box: light follow-ups
    // only — avoid starting another 3s poll interval here (hot path); form change still runs clnfScheduleClpPointsSync.
    var gen = ++notifyVariantFollowUpGen;
    syncClpPointsEarnedBox();
    requestAnimationFrame(function () { if (gen === notifyVariantFollowUpGen) syncClpPointsEarnedBox(); });
    setTimeout(function () { if (gen === notifyVariantFollowUpGen) syncClpPointsEarnedBox(); }, 0);
    setTimeout(function () { if (gen === notifyVariantFollowUpGen) syncClpPointsEarnedBox(); }, 85);
    scheduleNotifyUpdate();
    requestAnimationFrame(function () {
      if (gen !== notifyVariantFollowUpGen) return;
      syncClpPointsEarnedBox();
      scheduleNotifyUpdateImmediate();
      requestAnimationFrame(function () {
        if (gen !== notifyVariantFollowUpGen) return;
        syncClpPointsEarnedBox();
        scheduleNotifyUpdateImmediate();
      });
    });
    window.setTimeout(function () {
      if (gen !== notifyVariantFollowUpGen) return;
      syncClpPointsEarnedBox();
      scheduleNotifyUpdateImmediate();
    }, 70);
    window.setTimeout(function () {
      if (gen !== notifyVariantFollowUpGen) return;
      syncClpPointsEarnedBox();
      scheduleNotifyUpdateImmediate();
    }, 220);
    window.setTimeout(function () {
      if (gen !== notifyVariantFollowUpGen) return;
      syncClpPointsEarnedBox();
      scheduleNotifyUpdateImmediate();
    }, 420);
    window.setTimeout(function () {
      if (gen !== notifyVariantFollowUpGen) return;
      syncClpPointsEarnedBox();
      scheduleNotifyUpdateImmediate();
    }, 750);
  }
  ["variant:changed", "variant:change"].forEach(function (evtName) {
    document.addEventListener(evtName, scheduleNotifyCheckAfterVariantChange, { passive: true });
  });
  const variantSelectForNotify = document.querySelector(".product-single__variants");
  if (variantSelectForNotify) {
    variantSelectForNotify.addEventListener("change", scheduleNotifyCheckAfterVariantChange, { passive: true });
  }
  // WeTheme: onVariantChange() dispatches a native "change" on #AddToCartForm inside $nextTick after Vue
  // updates option1â€“3 / v-model â€” not the same as a select-only change when swatches drive state.
  // Document-level mousedown/click sync is in clnfBindAtcVariantSyncGuards (covers Upnova).
  const addToCartFormForNotify = document.querySelector("#AddToCartForm");
  if (addToCartFormForNotify) {
    addToCartFormForNotify.addEventListener(
      "submit",
      function () {
        clnfSyncVariantBeforeAtc();
      },
      true
    );
    addToCartFormForNotify.addEventListener("change", scheduleNotifyCheckAfterVariantChange, { passive: true });
    addToCartFormForNotify.addEventListener(
      "change",
      function () {
        clnfSyncProductVariantInUrl();
      },
      { passive: true }
    );
  }
  [0, 120, 450].forEach(function (ms) {
    window.setTimeout(clnfSyncProductVariantInUrl, ms);
  });

  checkAndUpdateNotifyButton();

  // MutationObserver to watch for button being re-added by third-party app
  _clnfNotifyObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) { // Element node
            // Check if the added node is the notify button or contains it
            if (node.id === 'pw_notify_popup_open') {
              // Check stock status BEFORE hiding - only hide if in stock
              const isOutOfStock = resolveOutOfStockState();

              // Only hide if product is in stock (button shouldn't be visible)
              if (!isOutOfStock) {
                hideNotifyButtonImmediately(node);
              }
              // Reset retry count since button was found
              notifyButtonRetryCount = 0;
              notifyAppLoadGivenUp = false;
              clearNotifyButtonRetrySchedule();
              scheduleNotifyUpdate();
            } else if (node.querySelector && node.querySelector('#pw_notify_popup_open')) {
              // Hide immediately if button is inside added node
              const button = node.querySelector('#pw_notify_popup_open');
              if (button) {
                // Check stock status BEFORE hiding - only hide if in stock
                const isOutOfStock = resolveOutOfStockState();

                // Only hide if product is in stock (button shouldn't be visible)
                if (!isOutOfStock) {
                  hideNotifyButtonImmediately(button);
                }
                // Reset retry count since button was found
                notifyButtonRetryCount = 0;
                notifyAppLoadGivenUp = false;
                clearNotifyButtonRetrySchedule();
              }
              scheduleNotifyUpdate();
            }
          }
        });
      }
    });
  });

  // Observe the narrowest available container; document.body is too broad (fires on every DOM mutation).
  var notifyObserverRoot =
    document.getElementById("AddToCartForm") ||
    document.querySelector(".product-form") ||
    document.querySelector('[id^="shopify-section-template--product"]') ||
    document.body;
  _clnfNotifyObserver.observe(notifyObserverRoot, {
    childList: true,
    subtree: true
  });

  window.addEventListener('pagehide', function () {
    if (_clnfNotifyObserver) { _clnfNotifyObserver.disconnect(); }
    if (_clnfGalleryHeightObs) { _clnfGalleryHeightObs.disconnect(); _clnfGalleryHeightObs = null; }
  });

  (function scheduleNotifyWhenProductFormReady() {
    var attempts = 0;
    var iv = setInterval(function () {
      var ready =
        !!document.querySelector("wetheme-product-form.product-form--ready") ||
        !!document.querySelector(".product-form-vue.product-form--ready");
      if (ready || ++attempts > 120) {
        clearInterval(iv);
        syncClpPointsEarnedBox();
        scheduleNotifyUpdateImmediate();
        setTimeout(scheduleNotifyUpdate, 200);
        clnfScheduleClpPointsSync();
      }
    }, 50);
  })();

  window.addEventListener("load", function () {
    scheduleNotifyUpdate();
    clnfScheduleClpPointsSync();
  });

  setTimeout(scheduleNotifyUpdate, 1000);

  setTimeout(scheduleNotifyUpdate, 3000);

  const skudisclaimer = new Set([
    "270226",
    "270222",
    "271242",
    "270542",
    "271215",
    "271340",
    "270515",
    "270005",
    "271213",
    "270513",
    "270003",
    "271216",
    "270516",
    "272016",
    "271217",
    "271218",
    "270517",
    "273017",
    "272017",
    "270518",
    "272018",
    "265010",
    "271674",
    "260523",
    "270735",
    "270725",
    "270745",
    "270216",
    "270215",
    "270266",
    "270271",
    "390335",
    "969329",
    "2204159",
    "270256",
    "270238",
    "270246",
    "352777",
    "161012",
    "160516",
    "274040",
  ]);

  function checkSkuDisclaimer(skuValue) {
    var checkBox = document.querySelector(".checkbox-wrapper");
    if (!checkBox) return;

    if (skudisclaimer.has(skuValue)) {
      checkBox.style.display = "block";
    } else {
      checkBox.style.display = "none";
    }
  }

  // SKU tabs (snippets/sku-tabs.liquid): sync highlighted row to selected variant.
  // Vue replaces option markup after mount; previous code cached .swatch-items-wrapper / .all-skus at DOMContentLoaded and listened on detached nodes.
  (function bindSkuTabsHighlightSync() {
    var ACTIVE = "active-sku--";
    var ACTIVE_NAME = "active-sku--name--";

    function skuFromAllSkusRow(el) {
      var i;
      var c;
      for (i = 0; i < el.classList.length; i++) {
        c = el.classList[i];
        if (c.indexOf(ACTIVE) !== 0) continue;
        if (c.indexOf(ACTIVE_NAME) === 0) continue;
        return c.slice(ACTIVE.length);
      }
      return "";
    }

    function syncSkuTabsHighlight(sku) {
      if (!sku) return;
      var rows = document.querySelectorAll(".all-skus");
      if (!rows.length) return;
      var names = document.querySelectorAll(".sku-name");
      rows.forEach(function (el) {
        el.classList.remove("current-sku");
      });
      names.forEach(function (el) {
        el.classList.add("hidden-skuname");
      });
      rows.forEach(function (el) {
        if (skuFromAllSkusRow(el) === sku) {
          el.classList.add("current-sku");
        }
      });
      names.forEach(function (el) {
        var i;
        var c;
        for (i = 0; i < el.classList.length; i++) {
          c = el.classList[i];
          if (c.indexOf(ACTIVE_NAME) === 0 && c.slice(ACTIVE_NAME.length) === sku) {
            el.classList.remove("hidden-skuname");
            break;
          }
        }
      });
    }

    function readSkuFromCheckedSwatchInput() {
      var input = document.querySelector(
        ".swatch-items-wrapper .swatch-element input:checked"
      );
      if (!input || !input.dataset) return "";
      return String(input.dataset.varinatsku || "").trim();
    }

    function readSkuFromVariantJson() {
      var form = document.getElementById("AddToCartForm");
      if (!form) return "";
      var idEl =
        clnfGetCanonicalVariantSelect(form) || form.querySelector('input[name="id"]');
      if (!idEl || idEl.value === undefined || idEl.value === null) return "";
      var product = getParsedProductJsonForClp();
      if (!product) return "";
      var vid = String(idEl.value).trim();
      if (!vid || !clnfVariantIdIsOnProduct(vid)) return "";
      var variants = product.variants || [];
      for (var j = 0; j < variants.length; j++) {
        if (String(variants[j].id) === vid) {
          return variants[j].sku ? String(variants[j].sku).trim() : "";
        }
      }
      return "";
    }

    function syncSkuTabsFromCurrentVariant() {
      var sku = readSkuFromCheckedSwatchInput();
      if (!sku) sku = readSkuFromVariantJson();
      if (sku) {
        syncSkuTabsHighlight(sku);
        checkSkuDisclaimer(sku);
      }
    }

    document.addEventListener(
      "click",
      function (e) {
        if (!e.target.closest(".swatch-items-wrapper")) return;
        var swatchEle = e.target.closest(".swatch-element");
        if (!swatchEle) return;
        var swatchInput = getSwatchInputFromEventTarget(e.target, swatchEle);
        activateSwatchInputFromTileClick(e.target, swatchInput);
        var input =
          swatchInput || swatchEle.querySelector("input[type='radio']");
        scheduleNotifyCheckAfterVariantChange();
        // Sync select immediately — rAF/timeout alone leaves a race where ATC uses the prior size.
        clnfSyncVariantSelectToSelectedOptions();
        window.requestAnimationFrame(clnfSyncVariantSelectToSelectedOptions);
        window.setTimeout(clnfSyncVariantSelectToSelectedOptions, 0);
        window.requestAnimationFrame(function () {
          var sku = readSkuFromCheckedSwatchInput();
          if (!sku && input && input.dataset && input.dataset.varinatsku) {
            sku = String(input.dataset.varinatsku).trim();
          }
          if (sku) {
            syncSkuTabsHighlight(sku);
            checkSkuDisclaimer(sku);
          }
        });
      },
      true
    );

    var formSku = document.getElementById("AddToCartForm");
    if (formSku) {
      formSku.addEventListener(
        "change",
        function () {
          window.requestAnimationFrame(syncSkuTabsFromCurrentVariant);
        },
        { passive: true }
      );
    }

    var skuPollN = 0;
    var skuPoll = setInterval(function () {
      syncSkuTabsFromCurrentVariant();
      if (clnfProductFormVueReadyPresent() || ++skuPollN >= 80) clearInterval(skuPoll);
    }, 50);

    syncSkuTabsFromCurrentVariant();
    window.addEventListener("load", syncSkuTabsFromCurrentVariant);
  })();

  /** Ajax cart: merge resolved PDP variant into cart/add only when the payload is clearly this product (not cross-sells). */
  (function clnfPatchCartAddVariantBody() {
    if (window.__clnfCartAddVariantBody) return;
    window.__clnfCartAddVariantBody = true;

    function numericVariantId(vid) {
      return /^\d+$/.test(String(vid)) ? parseInt(String(vid), 10) : vid;
    }

    function shouldPatchCartAddJson(data, vid, product) {
      if (!data || !vid || !product) return false;
      if (data.items && Array.isArray(data.items) && data.items[0]) {
        var it = data.items[0];
        if (it.product_id != null && String(it.product_id) === String(product.id)) return true;
        if (it.id != null && clnfVariantIdIsOnProduct(it.id)) return true;
        return false;
      }
      if (data.id != null && clnfVariantIdIsOnProduct(data.id)) return true;
      return false;
    }

    function mergeJsonBody(bodyStr, vid) {
      var product = getParsedProductJsonForClp();
      var data = JSON.parse(bodyStr);
      if (!shouldPatchCartAddJson(data, vid, product)) return bodyStr;
      var nvid = numericVariantId(vid);
      if (data.items && Array.isArray(data.items) && data.items[0]) {
        data.items[0].id = nvid;
      } else if (data.id != null) {
        data.id = nvid;
      }
      return JSON.stringify(data);
    }

    function mergeFormDataBody(fd, vid) {
      if (!fd || typeof fd.set !== "function") return;
      if (!shouldPatchCartAddId(typeof fd.get === "function" ? fd.get("id") : null)) return;
      fd.set("id", String(vid));
    }

    function mergeUrlEncodedString(bodyStr, vid) {
      try {
        var params = new URLSearchParams(bodyStr);
        if (!shouldPatchCartAddId(params.get("id"))) return bodyStr;
        params.set("id", String(vid));
        return params.toString();
      } catch (e) {
        return bodyStr;
      }
    }

    /**
     * Only rewrite `id` when the payload already targets one of THIS product's variants.
     * The recommendations grid ("You may also like") and other quick-add forms on a PDP post
     * form_type=product&id=<other product's variant>&quantity=N through the same fetch/XHR;
     * without this gate the PDP variant replaced theirs and the wrong item went into the cart.
     * Mirrors shouldPatchCartAddJson(). If the product JSON is unavailable we can't tell, so
     * fall back to the pre-existing behaviour (patch) to keep the swatch-race guard intact.
     */
    function shouldPatchCartAddId(currentId) {
      if (currentId == null || currentId === "") return false;
      var product = getParsedProductJsonForClp();
      if (!product || !Array.isArray(product.variants)) return true;
      return clnfVariantIdIsOnProduct(currentId);
    }

    function patchCartAddInit(input, init) {
      if (!document.getElementById("AddToCartForm")) return [input, init];
      if (!window.location.pathname || window.location.pathname.indexOf("/products/") !== 0) {
        return [input, init];
      }
      var path = typeof input === "string" ? input : input && input.url ? input.url : "";
      if (!path || path.indexOf("cart/add") === -1) return [input, init];
      var nextInit = init ? Object.assign({}, init) : {};
      if (String(nextInit.method || "GET").toUpperCase() !== "POST" || nextInit.body == null) {
        return [input, init];
      }
      var vid = clnfResolveAtcVariantId();
      if (!vid) return [input, init];

      var body = nextInit.body;
      try {
        if (typeof FormData !== "undefined" && body instanceof FormData) {
          mergeFormDataBody(body, vid);
          return [input, nextInit];
        }
        if (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams) {
          if (shouldPatchCartAddId(body.get("id"))) body.set("id", String(vid));
          return [input, nextInit];
        }
        if (typeof body === "string") {
          var t = body.trim();
          if (t.charAt(0) === "{" || t.charAt(0) === "[") {
            nextInit.body = mergeJsonBody(t, vid);
          } else if (t.indexOf("=") !== -1 && (t.indexOf("id=") !== -1 || t.indexOf("items%5B") !== -1)) {
            nextInit.body = mergeUrlEncodedString(t, vid);
          }
        }
      } catch (e) {}
      return [input, nextInit];
    }

    function installFetchWrap() {
      if (window.__clnfCartAddFetchWrapped) return;
      window.__clnfCartAddFetchWrapped = true;
      var prevFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        var patched = patchCartAddInit(input, init);
        return prevFetch(patched[0], patched[1]);
      };
    }
    installFetchWrap();
    [0, 50, 200, 600].forEach(function (ms) {
      setTimeout(installFetchWrap, ms);
    });

    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function (body) {
      try {
        var url = this.__clnfCartAddUrl || "";
        if (
          url.indexOf("cart/add") !== -1 &&
          String(this.__clnfCartAddMethod || "").toUpperCase() === "POST" &&
          document.getElementById("AddToCartForm") &&
          window.location.pathname &&
          window.location.pathname.indexOf("/products/") === 0
        ) {
          var vid = clnfResolveAtcVariantId();
          if (vid) {
            if (typeof FormData !== "undefined" && body instanceof FormData) {
              mergeFormDataBody(body, vid);
            } else if (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams) {
              if (shouldPatchCartAddId(body.get("id"))) body.set("id", String(vid));
            } else if (typeof body === "string") {
              var t = body.trim();
              if (t.charAt(0) === "{" || t.charAt(0) === "[") {
                body = mergeJsonBody(t, vid);
              } else if (t.indexOf("=") !== -1) {
                body = mergeUrlEncodedString(t, vid);
              }
            }
          }
        }
      } catch (e) {}
      return origSend.call(this, body);
    };
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__clnfCartAddUrl = typeof url === "string" ? url : "";
      this.__clnfCartAddMethod = method;
      return origOpen.apply(this, arguments);
    };
  })();

  let pailProduct = document.querySelector(
    '.js-qty[data-qty="pail-with-lid-5-gal-white"]'
  );
  let input = document.querySelector(
    '.js-qty[data-qty="pail-with-lid-5-gal-white"] input'
  );

  if (pailProduct) {
    pailProduct.querySelector("input").value = 2;
  }

  pailProduct?.addEventListener("click", function (e) {
    let minus = e.target.closest(
      '.js-qty[data-qty="pail-with-lid-5-gal-white"] .js-qty__adjust--minus'
    );
    if (!minus) return;
    pailProduct.querySelector("input").value =
      Number(pailProduct.querySelector("input").value) != 2
        ? Number(pailProduct.querySelector("input").value) - 2
        : 2;
  });

  pailProduct?.addEventListener("click", function (e) {
    let plus = e.target.closest(
      '.js-qty[data-qty="pail-with-lid-5-gal-white"] .js-qty__adjust--plus'
    );
    if (!plus) return;
    let inputBox = pailProduct.querySelector(
      '.js-qty[data-qty="pail-with-lid-5-gal-white"] input'
    );
    inputBox.value = Number(inputBox.value) + 2;
  });

  input?.addEventListener("change", function () {
    let evenNo = convertToEvenNumber(this.value * 1);
    if (evenNo >= 2) {
      this.value = evenNo;
    } else {
      this.value = 2;
    }
  });

  const convertToEvenNumber = function (no) {
    let evenNo = no % 2 != 0 ? no + 1 : no;
    return evenNo;
  };
}

if (document.readyState === "loading") {
  window.addEventListener("DOMContentLoaded", runProductCustomDomReady);
} else {
  runProductCustomDomReady();
}
